import _ from "lodash";
import { isValuePresent, applyOpacityToColor } from "../../utils/builderUtils";
import QuizOptionHeightService from "../../packs/services/convertflow/elements/quiz_option_height_service";

export const quizHasDefinedHeight = (options = {}) =>
  options["quiz-expand-to-browser-height"] === "true" ||
  options["quiz-expand-to-browser-height-mobile"] === "true" ||
  isValuePresent(options["quiz-height"]) ||
  isValuePresent(options["quiz-height-mobile"]);

export const resolveQuizClasses = (element, builder, device) => {
    let options = element.options;
    let classes = "element-content cf-quiz-element ";
    let alignmentClass = "cf-outer-center";

    if (device == "mobile") {
      if (options["cf-alignment-mobile"]) {
        if (options["cf-alignment-mobile"].indexOf("left") > -1) {
          alignmentClass = "cf-outer-left";
        } else if (options["cf-alignment-mobile"].indexOf("center") > -1) {
          alignmentClass = "cf-outer-center";
        } else if (options["cf-alignment-mobile"].indexOf("right") > -1) {
          alignmentClass = "cf-outer-right";
        }
      }
    } else {
      if (options["cf-alignment"]) {
        if (options["cf-alignment"].indexOf("left") > -1) {
          alignmentClass = "cf-outer-left";
        } else if (options["cf-alignment"].indexOf("center") > -1) {
          alignmentClass = "cf-outer-center";
        } else if (options["cf-alignment"].indexOf("right") > -1) {
          alignmentClass = "cf-outer-right";
        }
      }
    }

    classes += " " + alignmentClass;

    return classes;
};

export const buildQuizStylesheet = (builder, device, cta, element, variant, sorted_fields, section) => {
    let options = { ...element.options };

    let quizProgressLabelFormat = options["quiz-progress-label-format"];
    let quizProgressOuterWidth =
      options["quiz-progress-outer-width"] || undefined;

    let quizProgressOuterRadius = "";
    if (options["quiz-progress-outer-radius"] == "cf-not-rounded") {
      quizProgressOuterRadius = "0px";
    }
    if (options["quiz-progress-outer-radius"] == "cf-slightly-rounded") {
      quizProgressOuterRadius = "4px";
    }
    if (options["quiz-progress-outer-radius"] == "cf-fully-rounded") {
      quizProgressOuterRadius = "100px";
    }
    if (options["quiz-progress-outer-radius"] == "custom") {
      quizProgressOuterRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          quizProgressOuterRadius += `${
            _.isNil(options["quiz-progress-outer-radius-" + side]) == false
              ? options["quiz-progress-outer-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let quizMaxWidthElement = "";
    if (
      options["quiz-max-width-style"] == "custom" &&
      options["quiz-max-width-value"]
    ) {
      quizMaxWidthElement = `${options["quiz-max-width-value"]}px`;
    } else if (options["quiz-max-width-style"] == "full") {
      quizMaxWidthElement = "100%";
    }

    const expandToBrowser = options["quiz-expand-to-browser-height"] === "true";
    const expandToBrowserMobile =
      (options["quiz-expand-to-browser-height-mobile"] != null
        ? options["quiz-expand-to-browser-height-mobile"]
        : options["quiz-expand-to-browser-height"] != null
          ? options["quiz-expand-to-browser-height"]
          : "false") === "true";
    const hasQuizHeight = isValuePresent(options["quiz-height"]);
    const hasQuizHeightMobile = isValuePresent(options["quiz-height-mobile"]);
    const hasConstrainedHeight = expandToBrowser || hasQuizHeight;
    const hasConstrainedHeightMobile =
      expandToBrowserMobile || hasQuizHeightMobile;
    const quizHeightCss = (heightValue, expand) => {
      if (expand) {
        if (builder && device == "mobile") {
          return "height: 700px; overflow: auto;";
        }
        return "height: 90vh; height: 90dvh; overflow: auto;";
      }
      if (isValuePresent(heightValue)) {
        return `height: min(${heightValue}px, 100vh); height: min(${heightValue}px, 100dvh); overflow: auto;`;
      }
      return "";
    };

    let quizButtonsContainerWidth = options["quiz-buttons-container-width"]
      ? `${options["quiz-buttons-container-width"]}px`
      : "";
    let quizButtonsContainerWidthMobile = options[
      "quiz-buttons-container-width-mobile"
    ]
      ? `${options["quiz-buttons-container-width-mobile"]}px`
      : quizButtonsContainerWidth;

    // prettier-ignore

    let quizButtonBorderRadius = "";
    if (options["quiz-button-radius"] == "cf-not-rounded") {
      quizButtonBorderRadius = "0px";
    }
    if (options["quiz-button-radius"] == "cf-slightly-rounded") {
      quizButtonBorderRadius = "4px";
    }
    if (options["quiz-button-radius"] == "cf-fully-rounded") {
      quizButtonBorderRadius = "100px";
    }
    if (options["quiz-button-radius"] == "custom") {
      quizButtonBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          quizButtonBorderRadius += `${
            _.isNil(options["quiz-button-radius-" + side]) == false
              ? options["quiz-button-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let quizBackButtonBorderRadius = "";
    if (options["quiz-back-button-radius"] == "cf-not-rounded") {
      quizBackButtonBorderRadius = "0px";
    }
    if (options["quiz-back-button-radius"] == "cf-slightly-rounded") {
      quizBackButtonBorderRadius = "4px";
    }
    if (options["quiz-back-button-radius"] == "cf-fully-rounded") {
      quizBackButtonBorderRadius = "100px";
    }
    if (options["quiz-back-button-radius"] == "custom") {
      quizBackButtonBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          quizBackButtonBorderRadius += `${
            _.isNil(options["quiz-back-button-radius-" + side]) == false
              ? options["quiz-back-button-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    // Button spacing from options
    let quizButtonSpacingTop = 
      options["quiz-button-spacing-top"] 
      ? options["quiz-button-spacing-top"] 
      : variant.options["quiz-button-spacing-top"] 
      ? variant.options["quiz-button-spacing-top"] 
      : 0;

    let quizButtonSpacingTopMobile = 
      options["quiz-button-spacing-top-mobile"] 
      ? options["quiz-button-spacing-top-mobile"] 
      : variant.options["quiz-button-spacing-top-mobile"] 
      ? variant.options["quiz-button-spacing-top-mobile"] 
      : null;

    let quizButtonBoxShadow;
    let quizButtonBoxShadowHover;

    if (options["quiz-button-shadow"] == "None") {
      quizButtonBoxShadow = "none";
    }

    if (options["quiz-button-shadow"] == "soft") {
      quizButtonBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["quiz-button-shadow"] == "hard") {
      quizButtonBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    let quizButtonFont;
    if (
      options["quiz-button-font"] &&
      options["quiz-button-font"] !== "theme"
    ) {
      quizButtonFont = options["quiz-button-font"];
    }

    let quizButtonFontWeight;
    if (
      options["quiz-button-font-weight"] &&
      options["quiz-button-font-weight"] !== "theme"
    ) {
      quizButtonFontWeight = options["quiz-button-font-weight"];
    }

    let quizButtonFontSize;
    if (options["quiz-button-font-size"]) {
      quizButtonFontSize = options["quiz-button-font-size"];
    }

    if (options["quiz-button-shadow"] == "custom") {
      quizButtonBoxShadow = "";
      quizButtonBoxShadow +=
        (element.options["quiz-button-shadow-horizontal-distance"]
          ? `${element.options["quiz-button-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      quizButtonBoxShadow +=
        (element.options["quiz-button-shadow-vertical-distance"]
          ? `${element.options["quiz-button-shadow-vertical-distance"]}px`
          : "0px") + " ";

      quizButtonBoxShadow +=
        (element.options["quiz-button-shadow-blur-radius"]
          ? `${element.options["quiz-button-shadow-blur-radius"]}px`
          : "0px") + " ";

      quizButtonBoxShadow +=
        (element.options["quiz-button-shadow-spread-radius"]
          ? `${element.options["quiz-button-shadow-spread-radius"]}px`
          : "0px") + " ";

      quizButtonBoxShadow +=
        (element.options["quiz-button-shadow-color"]
          ? element.options["quiz-button-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";

      quizButtonBoxShadowHover =
        quizButtonBoxShadow +
        (element.options["quiz-button-hover-shadow-color"]
          ? element.options["quiz-button-hover-shadow-color"]
          : element.options["quiz-button-shadow-color"]
          ? element.options["quiz-button-shadow-color"]
          : "rgba(0,0,0, 0.35)");

      quizButtonBoxShadow +=
        element.options["quiz-button-shadow-inset"] == "true" ? "inset" : "";
      quizButtonBoxShadowHover +=
        element.options["quiz-button-shadow-inset"] == "true" ? "inset" : "";
    }

    let quizQuestionFontSize;
    if (
      options["quiz-question-font-size"] &&
      options["quiz-question-font-size"] !== "theme"
    ) {
      quizQuestionFontSize = options["quiz-question-font-size"];
    }

    let quizQuestionLineHeight;
    if (options["quiz-question-font-line-height"]) {
      quizQuestionLineHeight = options["quiz-question-font-line-height"];
    }

    let quizQuestionFontFamily;
    if (
      options["quiz-question-font-family"] &&
      options["quiz-question-font-family"] !== "theme"
    ) {
      quizQuestionFontFamily = options["quiz-question-font-family"];
    }

    let quizQuestionFontWeight;
    if (
      options["quiz-question-font-weight"] &&
      options["quiz-question-font-weight"] !== "theme"
    ) {
      quizQuestionFontWeight = options["quiz-question-font-weight"];
    }

    let quizQuestionFontColor;
    if (
      options["quiz-question-font-color"] &&
      options["quiz-question-font-color"] !== "theme"
    ) {
      quizQuestionFontColor = options["quiz-question-font-color"];
    }

    let quizDescriptionFontSize;
    if (
      options["quiz-description-font-size"] &&
      options["quiz-description-font-size"] !== "theme"
    ) {
      quizDescriptionFontSize = options["quiz-description-font-size"];
    }

    let quizDescriptionLineHeight;
    if (options["quiz-description-font-line-height"]) {
      quizDescriptionLineHeight = options["quiz-description-font-line-height"];
    }

    let quizDescriptionFontFamily;
    if (
      options["quiz-description-font-family"] &&
      options["quiz-description-font-family"] !== "theme"
    ) {
      quizDescriptionFontFamily = options["quiz-description-font-family"];
    }

    let quizDescriptionFontWeight;
    if (
      options["quiz-description-font-weight"] &&
      options["quiz-description-font-weight"] !== "theme"
    ) {
      quizDescriptionFontWeight = options["quiz-description-font-weight"];
    }

    let quizDescriptionFontColor;
    if (
      options["quiz-description-font-color"] &&
      options["quiz-description-font-color"] !== "theme"
    ) {
      quizDescriptionFontColor = options["quiz-description-font-color"];
    }

    let quizQuestionDistanceFromProgress =
      options["quiz-question-distance-from-progress"];

    let quizContentAlignment = "";
    let quizContentAlignmentMargin = "";
    switch (options["cf-content-alignment"]) {
      case "cf-left":
        quizContentAlignmentMargin = "margin-right: auto;";
        quizContentAlignment =
          "text-align: left !important; justify-content: flex-start !important; align-items: start; align-content: start; margin-left: 0px;";
        break;
      case "cf-center":
        quizContentAlignmentMargin = "margin-right: auto; margin-left: auto;";
        quizContentAlignment =
          "text-align: center !important; justify-content: center !important; align-items: center; align-content: center;";
        break;
      case "cf-right":
        quizContentAlignmentMargin = "margin-left: auto;";
        quizContentAlignment =
          "text-align: right !important; justify-content: flex-end !important; align-items: end; align-content: end; margin-right: 0px;";
        break;
    }

    let quizButtonAlignment = "";
    let stickyBarHorizontalPadding = "20px";
    let quizButtonContainerMargin = "";
    switch (options["quiz-button-alignment"]) {
      case "cf-outer-left":
        quizButtonAlignment = "justify-content: flex-start !important;";
        stickyBarHorizontalPadding = "0";
        quizButtonContainerMargin = "margin-left: 0; margin-right: auto;";
        break;
      case "cf-outer-right":
        quizButtonAlignment = "justify-content: flex-end !important;";
        stickyBarHorizontalPadding = "0";
        quizButtonContainerMargin = "margin-left: auto; margin-right: 0;";
        break;
      case "cf-outer-center":
        quizButtonAlignment = "justify-content: center !important;";
        quizButtonContainerMargin = "margin-left: auto; margin-right: auto;";
        break;
    }

    const buttonsContainedInContentCss = (contentWidth, buttonsContainerWidth) => {
      if (!isValuePresent(contentWidth)) return "";

      const narrowerButtons =
        isValuePresent(buttonsContainerWidth) &&
        Number(buttonsContainerWidth) < Number(contentWidth);

      if (!narrowerButtons) {
        return `max-width: ${contentWidth}px !important; width: 100%; margin-left: auto; margin-right: auto;`;
      }

      const inset = `max(0px, calc((100% - ${contentWidth}px) / 2))`;
      let horizontalMargin = "margin-left: auto; margin-right: auto;";
      if (options["quiz-button-alignment"] == "cf-outer-left") {
        horizontalMargin = `margin-left: ${inset}; margin-right: auto;`;
      } else if (options["quiz-button-alignment"] == "cf-outer-right") {
        horizontalMargin = `margin-left: auto; margin-right: ${inset};`;
      }

      return `max-width: ${buttonsContainerWidth}px !important; width: 100%; ${horizontalMargin}`;
    };

    const quizButtonsContentContainment = (
      fieldId,
      contentWidth,
      buttonsContainerWidth
    ) => {
      const css = buttonsContainedInContentCss(
        contentWidth,
        buttonsContainerWidth
      );
      if (!css) return "";

      return `
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${fieldId}"] .cf-quiz-buttons-wrapper,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${fieldId}"] .cf-quiz-sticky-buttons-inner {
          ${css}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${fieldId}"] .cf-quiz-sticky-bar.cf-quiz-sticky-bottom {
          padding-left: 0;
          padding-right: 0;
        }
      `;
    };

    let quizQuestionSpacing =
      options["quiz-question-spacing"] ||
      variant.options["quiz-question-spacing"] ||
      undefined;

    let quizConditionalContentBackgroundColor =
      options["quiz-conditional-content-background-color"] ||
      variant.options["quiz-conditional-content-background-color"] ||
      undefined;
    let quizConditionalContentBorderStyle =
      options["quiz-conditional-content-border-style"] ||
      variant.options["quiz-conditional-content-border-style"] ||
      "none";
    let quizConditionalContentHasBorder =
      quizConditionalContentBorderStyle !== "none";
    let quizConditionalContentBorderColor =
      options["quiz-conditional-content-border-color"] ||
      variant.options["quiz-conditional-content-border-color"] ||
      "#000";
    let quizConditionalContentPadding =
      options["quiz-conditional-content-padding"] ||
      variant.options["quiz-conditional-content-padding"] ||
      undefined;

    let quizConditionalContentBorderRadius = "4px";
    const conditionalContentRadiusSource = isValuePresent(
      options["quiz-conditional-content-border-radius"]
    )
      ? options
      : variant.options;
    if (
      conditionalContentRadiusSource["quiz-conditional-content-border-radius"] ==
      "cf-not-rounded"
    ) {
      quizConditionalContentBorderRadius = "0px";
    } else if (
      conditionalContentRadiusSource["quiz-conditional-content-border-radius"] ==
      "cf-fully-rounded"
    ) {
      quizConditionalContentBorderRadius = "100px";
    } else if (
      conditionalContentRadiusSource["quiz-conditional-content-border-radius"] ==
      "custom"
    ) {
      quizConditionalContentBorderRadius = [
        "top-left",
        "top-right",
        "bottom-right",
        "bottom-left",
      ]
        .map((side) => {
          const radius =
            conditionalContentRadiusSource[
              `quiz-conditional-content-border-radius-${side}`
            ];
          return `${_.isNil(radius) ? 4 : radius}px`;
        })
        .join(" ");
    }

    const quizConditionalContentBorderWidth = (side) => {
      if (
        _.isNil(options[`quiz-conditional-content-border-width-${side}`]) ==
        false
      ) {
        return options[`quiz-conditional-content-border-width-${side}`];
      }
      if (
        _.isNil(
          variant.options[`quiz-conditional-content-border-width-${side}`]
        ) == false
      ) {
        return variant.options[`quiz-conditional-content-border-width-${side}`];
      }
      return 0;
    };

    let quizButtonWidth;
    if (options["quiz-button-width"] == "cf-button-slim") {
      quizButtonWidth = "max-width: fit-content !important;"
    } else if (options["quiz-button-width"] == "cf-button-mid") {
      quizButtonWidth = "max-width: 250px !important;"
    } else if (options["quiz-button-width"] == "cf-full-width") {
      quizButtonWidth = "max-width: 100% !important;"
    } else if (
      options["quiz-button-width"] == "custom" &&
      options["quiz-button-width-value"]
    ) {
      quizButtonWidth =
        "max-width: " + options["quiz-button-width-value"] + "px !important;";
    } else if (!options["quiz-button-width"]) {
      quizButtonWidth = "max-width: fit-content !important;"
    }

    const explicitStickyBg = options["quiz-sticky-bar-background-color"];
    const stickyPageBg = variant.options["background-color"] || "#ffffff";
    const stickyStructure = section && section.options && section.options["structure"];
    const stickyOverlayRaw = stickyStructure && stickyStructure["background-color"];
    const stickyOverlay =
      stickyOverlayRaw && !stickyOverlayRaw.includes("gradient")
        ? stickyOverlayRaw
        : null;
    const stickyOverlayOpacity =
      stickyStructure && stickyStructure["background-opacity"] != null
        ? stickyStructure["background-opacity"]
        : 1;
    const stickyBarBackground = (direction) => {
      const fade = (color) => `linear-gradient(to ${direction}, ${color} 55%, transparent 100%)`;
      if (explicitStickyBg) return fade(explicitStickyBg);
      if (stickyOverlay) {
        return `${fade(applyOpacityToColor(stickyOverlay, stickyOverlayOpacity * 100))}, ${fade(stickyPageBg)}`;
      }
      return fade(stickyPageBg);
    };

    // prettier-ignore
    let desktopStyles =
    `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-element {
      ${quizMaxWidthElement ? `max-width: ${quizMaxWidthElement};` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question {
      max-width: 100%;
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-answers-wrapper,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-answers-wrapper .cf-form-2,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-buttons-wrapper {
      ${quizContentAlignment ? quizContentAlignment : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-description, #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-description * {
      ${quizDescriptionFontSize ? `font-size: ${quizDescriptionFontSize}px;` : ''}
      ${quizDescriptionFontWeight ? `font-weight: ${quizDescriptionFontWeight};` : ''}
      ${quizDescriptionFontColor ? `color: ${quizDescriptionFontColor};` : ''}
      ${quizDescriptionFontFamily && quizDescriptionFontFamily !== 'inherit' ? `font-family: ${quizDescriptionFontFamily}, sans-serif;` : ''}
      ${quizDescriptionLineHeight ? `line-height: ${quizDescriptionLineHeight}px;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-description,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-label {
      ${quizQuestionSpacing ? `margin-bottom: ${quizQuestionSpacing}px;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-answers-wrapper {
      ${quizQuestionSpacing ? `margin: ${quizQuestionSpacing}px 0px;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-conditional-content {
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      margin: 15px 0;
      ${quizConditionalContentBackgroundColor ? `background: ${quizConditionalContentBackgroundColor};` : ''}
      border-style: ${quizConditionalContentBorderStyle};
      ${quizConditionalContentHasBorder ? `border-color: ${quizConditionalContentBorderColor};` : ''}
      ${quizConditionalContentHasBorder ? `border-width: ${quizConditionalContentBorderWidth('top')}px ${quizConditionalContentBorderWidth('right')}px ${quizConditionalContentBorderWidth('bottom')}px ${quizConditionalContentBorderWidth('left')}px;` : ''}
      ${quizConditionalContentBorderRadius ? `border-radius: ${quizConditionalContentBorderRadius};` : ''}
      ${quizConditionalContentPadding ? `padding: ${quizConditionalContentPadding}px;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-conditional-content-item {
      width: 100%;
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-conditional-content-item img {
      max-width: 100%;
      height: auto;
      display: block;
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-label, #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-label * {
      ${quizQuestionFontSize ? `font-size: ${quizQuestionFontSize}px;` : ''}
      ${quizQuestionFontWeight ? `font-weight: ${quizQuestionFontWeight};` : ''}
      ${quizQuestionFontColor ? `color: ${quizQuestionFontColor};` : ''}
      ${quizQuestionFontFamily && quizQuestionFontFamily !== 'inherit' ? `font-family: ${quizQuestionFontFamily}, sans-serif;` : ''}
      ${quizQuestionLineHeight ? `line-height: ${quizQuestionLineHeight}px;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-label span[data-merge] {
      font-family: inherit !important;
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-description span[data-merge] {
      font-family: inherit !important;
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question .cf-progress {
      ${quizQuestionDistanceFromProgress ? `margin-bottom: ${quizQuestionDistanceFromProgress}px;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-button {
      ${options["quiz-button-color"] ? 'background: ' + options["quiz-button-color"] + '!important;' : ''}
      ${options["quiz-button-text-color"] ? 'color: ' + options["quiz-button-text-color"] + ' !important;' : ''}
      ${quizButtonWidth ? quizButtonWidth : ''}
      ${options["quiz-button-size"] == 'custom' && options["quiz-button-size-value"] ? 'padding: ' + options["quiz-button-size-value"] + 'px 20px !important;' : ''}
      ${options["quiz-button-border-style"] ? 'border-style: ' + options["quiz-button-border-style"] + ' !important;' : ''}
      ${options["quiz-button-border-style"] !== "" && _.isNil(options["quiz-button-border-width"]) == false ? 'border-width: ' + options["quiz-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-button-border-style"] !== "" && _.isNil(options["quiz-button-border-width-left"]) == false ? 'border-left-width: ' + options["quiz-button-border-width-left"] + 'px !important;' : _.isNil(options["quiz-button-border-width"]) == false ? 'border-left-width: ' + options["quiz-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-button-border-style"] !== "" && _.isNil(options["quiz-button-border-width-right"]) == false ? 'border-right-width: ' + options["quiz-button-border-width-right"] + 'px !important;' : _.isNil(options["quiz-button-border-width"]) == false ? 'border-right-width: ' + options["quiz-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-button-border-style"] !== "" && _.isNil(options["quiz-button-border-width-top"]) == false ? 'border-top-width: ' + options["quiz-button-border-width-top"] + 'px !important;' : _.isNil(options["quiz-button-border-width"]) == false ? 'border-top-width: ' + options["quiz-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-button-border-style"] !== "" && _.isNil(options["quiz-button-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["quiz-button-border-width-bottom"] + 'px !important;' : _.isNil(options["quiz-button-border-width"]) == false ? 'border-bottom-width: ' + options["quiz-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-button-border-style"] !== "" && options["quiz-button-border-color"] ? 'border-color: ' + options["quiz-button-border-color"] + ' !important;' : options["quiz-button-color"] ? 'border-color: ' + options["quiz-button-color"] + ' !important;' : ''}
      ${quizButtonBorderRadius ? 'border-radius: ' + quizButtonBorderRadius + ' !important;' : ''}
      ${quizButtonBoxShadow ? 'box-shadow: ' + quizButtonBoxShadow + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-button:hover, #cta_${cta.id} .cf-button:active {
      ${options["quiz-button–hover-color"] ? 'background: ' + options["quiz-button–hover-color"] + ' !important;' : options["quiz-button-color"] ? 'background: ' + options["quiz-button-color"] + ' !important;' : ''}
      ${options["quiz-button–hover-text-color"] ? 'color: ' + options["quiz-button–hover-text-color"] + ' !important;' : options["quiz-button-text-color"] ? 'color: ' + options["quiz-button-text-color"] + ' !important;' : ''}
      ${options["quiz-button-hover-border-color"] ? 'border-color: ' + options["quiz-button-hover-border-color"] + ' !important;' : options["quiz-button-border-color"] ? 'border-color: ' +  options["quiz-button-border-color"] + ' !important;' : ''}
      ${quizButtonBoxShadowHover ? 'box-shadow: ' + quizButtonBoxShadowHover + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-button p {
      ${quizButtonFont ? `font-family: ${quizButtonFont}, sans-serif !important;` : ''}
      ${quizButtonFontWeight ? `font-weight: ${quizButtonFontWeight} !important;` : ''}
      ${quizButtonFontSize ? `font-size: ${quizButtonFontSize}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-back-button {
      ${options["quiz-back-button-color"] ? `background: ${options["quiz-back-button-color"]} !important;` : ''}
      ${options["quiz-back-button-text-color"] ? `color: ${options["quiz-back-button-text-color"]} !important;` : ''}
      ${options["quiz-back-button-border-style"] ? 'border-style: ' + options["quiz-back-button-border-style"] + ' !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && _.isNil(options["quiz-back-button-border-width"]) == false ? 'border-width: ' + options["quiz-back-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && _.isNil(options["quiz-back-button-border-width-left"]) == false ? 'border-left-width: ' + options["quiz-back-button-border-width-left"] + 'px !important;' : _.isNil(options["quiz-button-border-width"]) == false ? 'border-left-width: ' + options["quiz-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && _.isNil(options["quiz-back-button-border-width-right"]) == false ? 'border-right-width: ' + options["quiz-back-button-border-width-right"] + 'px !important;' : _.isNil(options["quiz-back-button-border-width"]) == false ? 'border-right-width: ' + options["quiz-back-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && _.isNil(options["quiz-back-button-border-width-top"]) == false ? 'border-top-width: ' + options["quiz-back-button-border-width-top"] + 'px !important;' : _.isNil(options["quiz-back-button-border-width"]) == false ? 'border-top-width: ' + options["quiz-back-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && _.isNil(options["quiz-back-button-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["quiz-back-button-border-width-bottom"] + 'px !important;' : _.isNil(options["quiz-back-button-border-width"]) == false ? 'border-bottom-width: ' + options["quiz-back-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && options["quiz-back-button-border-color"] ? 'border-color: ' + options["quiz-back-button-border-color"] + ' !important;' : options["quiz-back-button-color"] ? 'border-color: ' + options["quiz-back-button-color"] + ' !important;' : ''}
      ${quizBackButtonBorderRadius ? 'border-radius: ' + quizBackButtonBorderRadius + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-back-button:hover, #cta_${cta.id} .cf-quiz-back-button:active {
      ${options["quiz-back-button–hover-color"] ? `background: ${options["quiz-back-button–hover-color"]} !important;` : options["quiz-button-color"] ? `background: ${options["quiz-button-color"]} !important;` : ''}
      ${options["quiz-back-button–hover-text-color"] ? `color: ${options["quiz-back-button–hover-text-color"]} !important;` : options["quiz-button-text-color"] ? `color: ${options["quiz-button-text-color"]} !important;` : ''}
      ${options["quiz-back-button-hover-border-color"] ? 'border-color: ' + options["quiz-back-button-hover-border-color"] + ' !important;' : options["quiz-back-button-border-color"] ? 'border-color: ' +  options["quiz-back-button-border-color"] + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .noUi-connect {
      ${_.isNil(options["quiz-field-border-color"]) == false ? `background: ${options["quiz-field-border-color"]} !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question .cf-progress {
      ${quizProgressOuterRadius ? `border-radius: ${quizProgressOuterRadius} !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question .cf-progress-inner {
      ${options["quiz-progress-inner-background-color"] ? `background: ${options["quiz-progress-inner-background-color"]} !important;` : variant.options["quiz-progress-inner-background-color"] ? "" : "background: #0D42E4;"}
      ${quizProgressLabelFormat !== "box" && options['quiz-progress-height'] ? `min-height: ${options['quiz-progress-height']}px !important;` : ''}
      ${quizProgressLabelFormat == "box" && options['quiz-progress-inner-padding'] ? `padding: ${options['quiz-progress-inner-padding']}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h1,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h2,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h3,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h4,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h5,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message p,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message span {
      ${options["quiz-progress-text-font"] ? `font-family: ${options["quiz-progress-text-font"]}, Helvetica, Arial, sans-serif !important;` : ''}
      ${options['quiz-progress-text-font-weight'] ? `font-weight: ${options['quiz-progress-text-font-weight']} !important;` : ''}
      ${options["quiz-progress-text-color"] ? `color: ${options["quiz-progress-text-color"]} !important;` : ''}
      ${options["quiz-progress-text-size"] ? `font-size: ${options["quiz-progress-text-size"]}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question .cf-progress-outer {
      ${quizProgressOuterRadius ? `border-radius: ${quizProgressOuterRadius} !important;` : ''}
      ${_.isNil(options["quiz-progress-border-width-left"]) == false ? `border-left-width: ${options["quiz-progress-border-width-left"]}px !important;` : ''}
      ${_.isNil(options["quiz-progress-border-width-right"]) == false ? `border-right-width: ${options["quiz-progress-border-width-right"]}px !important;` : ''}
      ${_.isNil(options["quiz-progress-border-width-bottom"]) == false ? `border-bottom-width: ${options["quiz-progress-border-width-bottom"]}px !important;` : ''}
      ${_.isNil(options["quiz-progress-border-width-top"]) == false ? `border-top-width: ${options["quiz-progress-border-width-top"]}px !important;` : ''}
      ${options["quiz-progress-outer-background-color"] ? `background: ${options["quiz-progress-outer-background-color"]} !important;` : variant.options["progress-outer-background-color"] ? variant.options["progress-outer-background-color"] : "background: #fff;"}
      ${options["quiz-progress-border-style"] ? `border-style: ${options["quiz-progress-border-style"]} !important;` : ''}
      ${options["quiz-progress-border-color"] ? `border-color: ${options["quiz-progress-border-color"]} !important;` : variant.options["progress-outer-border-color"] ? variant.options["progress-outer-border-color"] : "border-color: #000;"}
      ${quizProgressOuterWidth ? `width: ${quizProgressOuterWidth}px !important;` : 'width: 400px;'}
      ${quizProgressOuterWidth ? `flex-basis: ${quizProgressOuterWidth}px !important;` : 'flex-basis: 400px;'}
      flex-grow: 0;
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question .cf-progress-message {
      ${quizProgressLabelFormat == "line" ? 'flex: 0 0 100%; color: black;' : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-buttons-wrapper {
      ${quizButtonAlignment}
      ${quizButtonSpacingTop ? `margin-top: ${quizButtonSpacingTop}px !important;` : ''}
      ${quizButtonsContainerWidth ? `max-width: ${quizButtonsContainerWidth}; ${quizButtonContainerMargin || 'margin-left: auto; margin-right: auto;'}` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-buttons-inner {
      display: flex;
      align-items: center;
      ${quizButtonAlignment ? quizButtonAlignment : 'justify-content: center;'}
      gap: 10px;
      flex: 1 1 auto;
      width: 100%;
      min-width: 0;
      ${quizButtonsContainerWidth ? `max-width: ${quizButtonsContainerWidth};` : ''}
      ${quizButtonContainerMargin || 'margin-left: auto; margin-right: auto;'}
      box-sizing: border-box;
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-buttons-wrapper > .cf-button {
      flex: 0 1 auto;
      width: 100%;
      min-width: 0;
    }

    ${hasConstrainedHeight ? `
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-inner-wrapper {
      ${quizHeightCss(options["quiz-height"], expandToBrowser)}
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }
    ` : ""}

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar {
      position: ${builder && !hasConstrainedHeight ? "relative" : "sticky"};
      z-index: 10;
      width: 100%;
      box-sizing: border-box;
      background: transparent;
      isolation: isolate;
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar::before {
      content: '';
      position: absolute;
      inset: 0;
      z-index: -1;
      pointer-events: none;
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar.cf-quiz-sticky-top {
      top: 0;
      padding: 15px 20px 36px;
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar.cf-quiz-sticky-top::before {
      background: ${stickyBarBackground("bottom")};
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar.cf-quiz-sticky-bottom {
      bottom: 0;
      display: flex;
      align-items: center;
      ${quizButtonAlignment ? quizButtonAlignment : 'justify-content: center;'}
      ${hasConstrainedHeight ? "margin-top: auto;" : ""}
      flex-shrink: 0;
      padding: 36px ${stickyBarHorizontalPadding} 15px;
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar.cf-quiz-sticky-bottom::before {
      background: ${stickyBarBackground("top")};
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bottom .cf-quiz-back-button {
      flex: 0 0 auto;
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bottom .cf-quiz-next-button {
      flex: 0 1 auto;
      min-width: 0;
      width: 100%;
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar .cf-progress {
      width: 100%;
      margin: 0 !important;
    }
    `;

    // prettier-ignore
    const optionBorderStyles = (field_item, show = true) => {
      let quizOptionBorderRadius = "";

      if (field_item.options["quiz-option-border-radius"] == "cf-not-rounded") {
        quizOptionBorderRadius = "0px";
      } else if (field_item.options["quiz-option-border-radius"] == "cf-slightly-rounded") {
        quizOptionBorderRadius = "4px";
      } else if (field_item.options["quiz-option-border-radius"] == "cf-fully-rounded") {
        quizOptionBorderRadius = "100px";
      } else if (field_item.options["quiz-option-border-radius"] == "custom") {
        quizOptionBorderRadius = "";
        ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
          (side) => {
            quizOptionBorderRadius += `${
              _.isNil(field_item.options["quiz-option-border-radius-" + side]) == false
                ? field_item.options["quiz-option-border-radius-" + side]
                : "4"
            }px `;
          }
        );
      } else if (variant.options["quiz-option-border-radius"] == "cf-not-rounded") {
        quizOptionBorderRadius = "0px";
      } else if (variant.options["quiz-option-border-radius"] == "cf-slightly-rounded") {
        quizOptionBorderRadius = "4px";
      } else if (variant.options["quiz-option-border-radius"] == "cf-fully-rounded") {
        quizOptionBorderRadius = "100px";
      } else if (variant.options["quiz-option-border-radius"] == "custom") {
        quizOptionBorderRadius = "";
        ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
          (side) => {
            quizOptionBorderRadius += `${
              _.isNil(variant.options["quiz-option-border-radius-" + side]) == false
                ? variant.options["quiz-option-border-radius-" + side]
                : "4"
            }px `;
          }
        );
      } else {
        quizOptionBorderRadius = "4px";
      }

      let borderStyle = field_item.options["quiz-option-border-style"] || element.options["quiz-option-border-style"] || variant.options["quiz-option-border-style"] || 'solid';

      let optionBorderWidth = 2;
      if (isValuePresent(field_item.options["quiz-option-border-width"])) {
        optionBorderWidth = field_item.options["quiz-option-border-width"];
      } else if (isValuePresent(variant.options["quiz-option-border-width"])) {
        optionBorderWidth = variant.options["quiz-option-border-width"];
      }

      let optionBorderWidthLeft = 2;
      if (isValuePresent(field_item.options["quiz-option-border-width-left"])) {
        optionBorderWidthLeft = field_item.options["quiz-option-border-width-left"];
      } else if (isValuePresent(variant.options["quiz-option-border-width-left"])) {
        optionBorderWidthLeft = variant.options["quiz-option-border-width-left"];
      }

      let optionBorderWidthRight = 2;
      if (isValuePresent(field_item.options["quiz-option-border-width-right"])) {
        optionBorderWidthRight = field_item.options["quiz-option-border-width-right"];
      } else if (isValuePresent(variant.options["quiz-option-border-width-right"])) {
        optionBorderWidthRight = variant.options["quiz-option-border-width-right"];
      }

      let optionBorderWidthTop = 2;
      if (isValuePresent(field_item.options["quiz-option-border-width-top"])) {
        optionBorderWidthTop = field_item.options["quiz-option-border-width-top"];
      } else if (isValuePresent(variant.options["quiz-option-border-width-top"])) {
        optionBorderWidthTop = variant.options["quiz-option-border-width-top"];
      }

      let optionBorderWidthBottom = 2;
      if (isValuePresent(field_item.options["quiz-option-border-width-bottom"])) {
        optionBorderWidthBottom = field_item.options["quiz-option-border-width-bottom"];
      } else if (isValuePresent(variant.options["quiz-option-border-width-bottom"])) {
        optionBorderWidthBottom = variant.options["quiz-option-border-width-bottom"];
      }

      let optionBorderColor = field_item.options["quiz-option-border-color"] || element.options["quiz-option-border-color"] || variant.options["quiz-option-border-color"] || undefined;

      let optionBorderStyles = `
        ${show ? `border-style: ${borderStyle};` : 'border-style: none;'}
        ${_.isNil(optionBorderWidth) == false ? `border-width: ${optionBorderWidth}px;` : ''}
        ${_.isNil(optionBorderWidthLeft) == false ? `border-left-width: ${optionBorderWidthLeft}px;` : ''}
        ${_.isNil(optionBorderWidthRight) == false ? `border-right-width: ${optionBorderWidthRight}px;` : ''}
        ${_.isNil(optionBorderWidthTop) == false ? `border-top-width: ${optionBorderWidthTop}px;` : ''}
        ${_.isNil(optionBorderWidthBottom) == false ? `border-bottom-width: ${optionBorderWidthBottom}px;` : ''}
        ${_.isNil(optionBorderColor) == false ? `border-color: ${optionBorderColor};` : ''}
        ${quizOptionBorderRadius ? `border-radius: ${quizOptionBorderRadius};` : ''}
      `
      return optionBorderStyles
    }

    // prettier-ignore
    const hoverOptionStyles = (field_item, show) => {
      let hoverOptionStyles;

      let optionBorderColor = field_item.options["quiz-hover-option-border-color"] || element.options["quiz-hover-option-border-color"] || variant.options["quiz-hover-option-border-color"] || undefined;
      let optionBackgroundColor = field_item.options["quiz-hover-option-background-color"] || element.options["quiz-hover-option-background-color"] || variant.options["quiz-hover-option-background-color"] || undefined;

      if (show) {
        hoverOptionStyles = `
          ${_.isNil(optionBorderColor) == false ? `border-color: ${optionBorderColor} !important;` : ''}
          ${_.isNil(optionBackgroundColor) == false ? `background: ${optionBackgroundColor} !important;` : ''}
        `
      }

      return hoverOptionStyles
    }

    // prettier-ignore
    const selectedOptionBorderStyles = (field_item, show = true) => {
      let selectedOptionBorderStyles = '';
      let optionSelectedStyle = field_item.options["quiz-selected-option-style"] || element.options["quiz-selected-option-style"] || variant.options["quiz-selected-option-style"] || 'transparent';

      if (optionSelectedStyle == "transparent") {
        selectedOptionBorderStyles = `
          opacity: 0.5;
        `
      } else {
        let borderStyle = field_item.options["quiz-selected-option-border-style"] || element.options["quiz-selected-option-border-style"] || variant.options["quiz-selected-option-border-style"] || field_item.options["quiz-option-border-style"] || field_item.options["quiz-option-border-style"] || variant.options["quiz-option-border-style"] || 'solid';
        let optionBorderWidth;
        if (isValuePresent(field_item.options["quiz-selected-option-border-width"])) {
          optionBorderWidth = field_item.options["quiz-selected-option-border-width"];
        } else if (isValuePresent(variant.options["quiz-selected-option-border-width"])) {
          optionBorderWidth = variant.options["quiz-selected-option-border-width"];
        }

        let optionBorderWidthLeft;
        if (isValuePresent(field_item.options["quiz-selected-option-border-width-left"])) {
          optionBorderWidthLeft = field_item.options["quiz-selected-option-border-width-left"];
        } else if (isValuePresent(variant.options["quiz-selected-option-border-width-left"])) {
          optionBorderWidthLeft = variant.options["quiz-selected-option-border-width-left"];
        }

        let optionBorderWidthRight;
        if (isValuePresent(field_item.options["quiz-selected-option-border-width-right"])) {
          optionBorderWidthRight = field_item.options["quiz-selected-option-border-width-right"];
        } else if (isValuePresent(variant.options["quiz-selected-option-border-width-right"])) {
          optionBorderWidthRight = variant.options["quiz-selected-option-border-width-right"];
        }

        let optionBorderWidthTop;
        if (isValuePresent(field_item.options["quiz-selected-option-border-width-top"])) {
          optionBorderWidthTop = field_item.options["quiz-selected-option-border-width-top"];
        } else if (isValuePresent(variant.options["quiz-selected-option-border-width-top"])) {
          optionBorderWidthTop = variant.options["quiz-selected-option-border-width-top"];
        }

        let optionBorderWidthBottom;
        if (isValuePresent(field_item.options["quiz-selected-option-border-width-bottom"])) {
          optionBorderWidthBottom = field_item.options["quiz-selected-option-border-width-bottom"];
        } else if (isValuePresent(variant.options["quiz-selected-option-border-width-bottom"])) {
          optionBorderWidthBottom = variant.options["quiz-selected-option-border-width-bottom"];
        }
        let optionBorderColor = field_item.options["quiz-selected-option-border-color"] || element.options["quiz-selected-option-border-color"] || variant.options["quiz-selected-option-border-color"] || undefined;

        selectedOptionBorderStyles = `
          ${show ? `border-style: ${borderStyle} !important;` : 'border-style: none !important;'}
          ${_.isNil(optionBorderWidth) == false ? `border-width: ${optionBorderWidth}px;` : ''}
          ${_.isNil(optionBorderWidthLeft) == false ? `border-left-width: ${optionBorderWidthLeft}px;` : ''}
          ${_.isNil(optionBorderWidthRight) == false ? `border-right-width: ${optionBorderWidthRight}px;` : ''}
          ${_.isNil(optionBorderWidthTop) == false ? `border-top-width: ${optionBorderWidthTop}px;` : ''}
          ${_.isNil(optionBorderWidthBottom) == false ? `border-bottom-width: ${optionBorderWidthBottom}px;` : ''}
          ${_.isNil(optionBorderColor) == false ? `border-color: ${optionBorderColor};` : ''}
        `
      }

      return selectedOptionBorderStyles
    }

    const quizOptionHeightAuto = (field_item) =>
      QuizOptionHeightService.resolvedValue(element, variant, field_item) ==
      "auto";

    const resolveQuizOptionWidth = (field_item) => {
      if (
        field_item.options["quiz-option-width-value"] &&
        field_item.options["quiz-option-width-style"] == "custom"
      ) {
        return `${field_item.options["quiz-option-width-value"]}px`;
      } else if (field_item.options["quiz-option-width-style"] == "regular") {
        return "300px";
      } else if (field_item.options["quiz-option-width-style"] == "full") {
        return "100%";
      } else if (field_item.options["quiz-option-width-style"] == "auto") {
        return "auto";
      } else if (
        element.options["quiz-option-width-style"] == "custom" &&
        element.options["quiz-option-width-value"]
      ) {
        return `${element.options["quiz-option-width-value"]}px`;
      } else if (element.options["quiz-option-width-style"] == "regular") {
        return "300px";
      } else if (element.options["quiz-option-width-style"] == "full") {
        return "100%";
      } else if (element.options["quiz-option-width-style"] == "auto") {
        return "auto";
      } else if (
        variant.options["quiz-option-width-value"] &&
        variant.options["quiz-option-width-style"] == "custom"
      ) {
        return `${variant.options["quiz-option-width-value"]}px`;
      } else if (variant.options["quiz-option-width-style"] == "regular") {
        return "300px";
      } else if (variant.options["quiz-option-width-style"] == "full") {
        return "100%";
      } else {
        return "auto";
      }
    };

    // INDIVIDUAL OPTIONS STYLES
    // prettier-ignore
    Object.values(sorted_fields).forEach((field_item) => {
      let quizOptionFontFamily;
      if (
        field_item.options["quiz-option-font-family"] &&
        field_item.options["quiz-option-font-family"] !== "theme"
      ) {
        quizOptionFontFamily = field_item.options["quiz-option-font-family"];
      } else if (
        element.options["quiz-option-font-family"] &&
        element.options["quiz-option-font-family"] !== "theme"
      ) {
        quizOptionFontFamily = element.options["quiz-option-font-family"];
      }

      let quizOptionFontLineHeight;
      if (
        field_item.options["quiz-option-font-line-height"] &&
        field_item.options["quiz-option-font-line-height"] !== "theme"
      ) {
        quizOptionFontLineHeight = field_item.options["quiz-option-font-line-height"];
      } else if (
        element.options["quiz-option-font-line-height"] &&
        element.options["quiz-option-font-line-height"] !== "theme"
      ) {
        quizOptionFontLineHeight = element.options["quiz-option-font-line-height"];
      }

      let quizOptionFontWeight;
      if (
        field_item.options["quiz-option-font-weight"] &&
        field_item.options["quiz-option-font-weight"] !== "theme"
      ) {
        quizOptionFontWeight = field_item.options["quiz-option-font-weight"];
      } else if (
        element.options["quiz-option-font-weight"] &&
        element.options["quiz-option-font-weight"] !== "theme"
      ) {
        quizOptionFontWeight = element.options["quiz-option-font-weight"];
      }

      let quizOptionVisualColor = field_item.options["quiz-option-color"] || element.options["quiz-option-color"] || undefined
      let quizHoverOptionVisualColor = field_item.options["quiz-hover-option-color"] || element.options["quiz-hover-option-color"] || undefined;

      let quizOptionFontColor;
      if (
        field_item.options["quiz-option-font-color"] &&
        field_item.options["quiz-option-font-color"] !== "theme"
      ) {
        quizOptionFontColor = field_item.options["quiz-option-font-color"];
      } else if (
        element.options["quiz-option-font-color"] &&
        element.options["quiz-option-font-color"] !== "theme"
      ) {
        quizOptionFontColor = element.options["quiz-option-font-color"];
      }

      let quizOptionVisualFontSize = field_item.options["quiz-option-visual-font-size"] || element.options["quiz-option-visual-font-size"] || undefined

      let quizOptionFontSize;
      if (
        field_item.options["quiz-option-font-size"] &&
        field_item.options["quiz-option-font-size"] !== "theme"
      ) {
        quizOptionFontSize = field_item.options["quiz-option-font-size"];
      } else if (
        element.options["quiz-option-font-size"] &&
        element.options["quiz-option-font-size"] !== "theme"
      ) {
        quizOptionFontSize = element.options["quiz-option-font-size"];
      }

      let quizOptionWidth = resolveQuizOptionWidth(field_item);

      let quizImagePlacement = isValuePresent(field_item.options["quiz-image-placement"])
        ? field_item.options["quiz-image-placement"]
        : element.options["quiz-image-placement"] || variant.options["quiz-image-placement"] || 'centered';

      let quizOptionImageWidth = isValuePresent(field_item.options["quiz-option-image-width"])
        ? field_item.options["quiz-option-image-width"]
        : element.options["quiz-option-image-width"] || 110;

      let quizOptionImageHeight = isValuePresent(field_item.options["quiz-option-image-height"])
        ? field_item.options["quiz-option-image-height"]
        : element.options["quiz-option-image-height"] || quizOptionImageWidth;

      let quizVisualPlacement = isValuePresent(field_item.options["quiz-visual-placement"])
        ? field_item.options["quiz-visual-placement"]
        : element.options["quiz-visual-placement"] || variant.options["quiz-visual-placement"] || 'centered';

      let quizImagePlacementWidth;
      if (quizImagePlacement == "centered") {
        quizImagePlacementWidth = "100%";
      } else if (quizImagePlacement == "left") {
        // Size to the custom image width, not visual-font-size (letter/icon/emoji).
        quizImagePlacementWidth = `${quizOptionImageWidth}px`;
      }

      let quizVisualPlacementWidth;
      if (quizVisualPlacement == "centered") {
        quizVisualPlacementWidth = "100%";
      } else if (quizVisualPlacement == "left") {
        quizVisualPlacementWidth = quizOptionVisualFontSize
          ? `${parseInt(quizOptionVisualFontSize) * 0.6}%`
          : "10%";
      }

      let quizOptionColorSize = isValuePresent(field_item.options["quiz-option-color-size"])
        ? field_item.options["quiz-option-color-size"]
        : element.options["quiz-option-color-size"] || undefined;

      let quizSelectedOptionFontColor = field_item.options["quiz-selected-option-font-color"] || element.options["quiz-selected-option-font-color"] || variant.options["quiz-selected-option-font-color"] || undefined;
      let quizHoverOptionFontColor = isValuePresent(field_item.options["quiz-hover-option-font-color"])
        ? field_item.options["quiz-hover-option-font-color"]
        : element.options["quiz-hover-option-font-color"] || variant.options["quiz-hover-option-font-color"] || undefined;

      let quizOptionBackgroundColor = isValuePresent(field_item.options["quiz-option-background-color"])
        ? field_item.options["quiz-option-background-color"]
        : element.options["quiz-option-background-color"] || variant.options["quiz-option-background-color"] || undefined;

      let quizSelectedOptionBackgroundColor = field_item.options["quiz-selected-option-background-color"] || element.options["quiz-selected-option-background-color"] || variant.options["quiz-selected-option-background-color"] || undefined;

      let quizOptionBoxShadow;

      if (field_item.options["quiz-option-box-shadow"]) {
        if (field_item.options["quiz-option-box-shadow"] == "soft") {
          quizOptionBoxShadow = "0 3px 5px rgb(179 179 179 / 78%)";
        }
        if (field_item.options["quiz-option-box-shadow"] == "hard") {
          quizOptionBoxShadow = "-3px 3px 0 rgb(0 0 0 / 10%)";
        }
        if (field_item.options["quiz-option-box-shadow"] == "None") {
          quizOptionBoxShadow = "unset";
        }
        if (field_item.options["quiz-option-box-shadow"] == "custom") {
          quizOptionBoxShadow = "";
          quizOptionBoxShadow +=
            (field_item.options["quiz-option-box-shadow-horizontal-distance"]
              ? `${field_item.options["quiz-option-box-shadow-horizontal-distance"]}px`
              : element.options["quiz-option-box-shadow-horizontal-distance"]
                ? `${element.options["quiz-option-box-shadow-horizontal-distance"]}px`
                : variant.options["quiz-option-box-shadow-horizontal-distance"]
                  ? `${variant.options["quiz-option-box-shadow-horizontal-distance"]}px`
                  : "0px") + " ";

          quizOptionBoxShadow +=
            (field_item.options["quiz-option-box-shadow-vertical-distance"]
              ? `${field_item.options["quiz-option-box-shadow-vertical-distance"]}px`
              : element.options["quiz-option-box-shadow-vertical-distance"]
                ? `${element.options["quiz-option-box-shadow-vertical-distance"]}px`
                : variant.options["quiz-option-box-shadow-vertical-distance"]
                  ? `${variant.options["quiz-option-box-shadow-vertical-distance"]}px`
                  : "0px") + " ";

          quizOptionBoxShadow +=
            (field_item.options["quiz-option-box-shadow-blur-radius"]
              ? `${field_item.options["quiz-option-box-shadow-blur-radius"]}px`
              : element.options["quiz-option-box-shadow-blur-radius"]
                ? `${element.options["quiz-option-box-shadow-blur-radius"]}px`
                : variant.options["quiz-option-box-shadow-blur-radius"]
                  ? `${variant.options["quiz-option-box-shadow-blur-radius"]}px`
                  : "0px") + " ";

          quizOptionBoxShadow +=
            (field_item.options["quiz-option-box-shadow-color"]
              ? field_item.options["quiz-option-box-shadow-color"]
              : element.options["quiz-option-box-shadow-color"]
                ? element.options["quiz-option-box-shadow-color"]
                : variant.options["quiz-option-box-shadow-color"]
                  ? variant.options["quiz-option-box-shadow-color"]
                  : "rgba(0,0,0, 0.35)") + " ";
        }
      } else if (element.options["quiz-option-box-shadow"]) {
        if (element.options["quiz-option-box-shadow"] == "soft") {
          quizOptionBoxShadow = "0 3px 5px rgb(179 179 179 / 78%)";
        }
        if (element.options["quiz-option-box-shadow"] == "hard") {
          quizOptionBoxShadow = "-3px 3px 0 rgb(0 0 0 / 10%)";
        }
        if (element.options["quiz-option-box-shadow"] == "None") {
          quizOptionBoxShadow = "unset";
        }
        if (element.options["quiz-option-box-shadow"] == "custom") {
          quizOptionBoxShadow = "";
          quizOptionBoxShadow +=
            (element.options["quiz-option-box-shadow-horizontal-distance"]
              ? `${element.options["quiz-option-box-shadow-horizontal-distance"]}px`
              : variant.options["quiz-option-box-shadow-horizontal-distance"]
                ? `${variant.options["quiz-option-box-shadow-horizontal-distance"]}px`
                : "0px") + " ";

          quizOptionBoxShadow +=
            (element.options["quiz-option-box-shadow-vertical-distance"]
              ? `${element.options["quiz-option-box-shadow-vertical-distance"]}px`
              : variant.options["quiz-option-box-shadow-vertical-distance"]
                ? `${variant.options["quiz-option-box-shadow-vertical-distance"]}px`
                : "0px") + " ";

          quizOptionBoxShadow +=
            (element.options["quiz-option-box-shadow-blur-radius"]
              ? `${element.options["quiz-option-box-shadow-blur-radius"]}px`
              : variant.options["quiz-option-box-shadow-blur-radius"]
                ? `${variant.options["quiz-option-box-shadow-blur-radius"]}px`
                : "0px") + " ";

          quizOptionBoxShadow +=
            (element.options["quiz-option-box-shadow-color"]
              ? element.options["quiz-option-box-shadow-color"]
              : variant.options["quiz-option-box-shadow-color"]
                ? variant.options["quiz-option-box-shadow-color"]
                : "rgba(0,0,0, 0.35)") + " ";
        }
      }

      let quizFieldFontSize;
      if (field_item.options["quiz-answer-field-font-size"]) {
        quizFieldFontSize = field_item.options["quiz-answer-field-font-size"];
      } else if (element.options["quiz-answer-field-font-size"]) {
        quizFieldFontSize = element.options["quiz-answer-field-font-size"];
      }

      let intFieldSizeValue = isValuePresent(field_item.options["quiz-answer-field-size-value"])
        ? parseInt(field_item.options["quiz-answer-field-size-value"])
        : parseInt(element.options["quiz-answer-field-size-value"]);

      let quizFieldConsideredFontSize = quizFieldFontSize || variant.options["field-font-size"] || 15;
      let quizFieldInputPaddingFormula = Math.floor((quizFieldConsideredFontSize * 1.5) / 4 / 2);

      // prettier-ignore
      let customInputPaddingCalculated = `${intFieldSizeValue + quizFieldInputPaddingFormula}px
        ${intFieldSizeValue}px
        ${intFieldSizeValue + quizFieldInputPaddingFormula}px
        ${intFieldSizeValue}px`;

      // source: app/views/cta/_css.html.erb:2026
      let regularInputPadding = {
        top: 11,
        right: 0,
        bottom: 9,
        left: 10,
      };

      // source: app/views/cta/_css.html.erb:2074
      let largeInputPadding = {
        top: 12,
        right: 0,
        bottom: 10,
        left: 10,
      };

      // prettier-ignore
      let regularInputPaddingCalculated = `${regularInputPadding["top"] + quizFieldInputPaddingFormula}px
        ${regularInputPadding["right"]}px
        ${regularInputPadding["bottom"] + quizFieldInputPaddingFormula}px
        ${regularInputPadding["left"]}px`;

      // prettier-ignore
      let largeInputPaddingCalculated = `${largeInputPadding["top"] + quizFieldInputPaddingFormula}px
        ${largeInputPadding["right"]}px
        ${largeInputPadding["bottom"] + quizFieldInputPaddingFormula}px
        ${largeInputPadding["left"]}px`;

      let quizFieldFontWeight;
      if (
        field_item.options["quiz-answer-field-font-weight"] &&
        field_item.options["quiz-answer-field-font-weight"] !== "theme"
      ) {
        quizFieldFontWeight = field_item.options["quiz-answer-field-font-weight"];
      } else if (
        element.options["quiz-answer-field-font-weight"] &&
        element.options["quiz-answer-field-font-weight"] !== "theme"
      ) {
        quizFieldFontWeight = element.options["quiz-answer-field-font-weight"];
      }

      let quizFieldRadius;
      if (field_item.options["quiz-answer-field-rounded"] == "cf-field-not-rounded") {
        quizFieldRadius = "0px";
      }
      if (field_item.options["quiz-answer-field-rounded"] == "cf-field-slightly-rounded") {
        quizFieldRadius = "3px";
      }
      if (field_item.options["quiz-answer-field-rounded"] == "cf-field-fully-rounded") {
        quizFieldRadius = "100px";
      }
      if (field_item.options["quiz-answer-field-rounded"] == "custom") {
        quizFieldRadius = "";
        ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
          (side) => {
            quizFieldRadius += `${
              _.isNil(field_item.options["quiz-answer-field-radius-" + side]) == false
                ? field_item.options["quiz-answer-field-radius-" + side]
                : "3"
            }px `;
          }
        );
      }

      let quizFieldBoxShadow;

      if (field_item.options["quiz-answer-field-box-shadow"] == "soft") {
        quizFieldBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
      }

      if (field_item.options["quiz-answer-field-box-shadow"] == "hard") {
        quizFieldBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
      }

      if (field_item.options["quiz-answer-field-box-shadow"] == "custom") {
        quizFieldBoxShadow = "";
        quizFieldBoxShadow +=
          (field_item.options["quiz-answer-field-box-shadow-horizontal-distance"]
            ? `${field_item.options["quiz-answer-field-box-shadow-horizontal-distance"]}px`
            : "0px") + " ";

        quizFieldBoxShadow +=
          (field_item.options["quiz-answer-field-box-shadow-vertical-distance"]
            ? `${field_item.options["quiz-answer-field-box-shadow-vertical-distance"]}px`
            : "0px") + " ";

        quizFieldBoxShadow +=
          (field_item.options["quiz-answer-field-box-shadow-blur-radius"]
            ? `${field_item.options["quiz-answer-field-box-shadow-blur-radius"]}px`
            : "0px") + " ";

        quizFieldBoxShadow +=
          (field_item.options["quiz-answer-field-box-shadow-spread-radius"]
            ? `${field_item.options["quiz-answer-field-box-shadow-spread-radius"]}px`
            : "0px") + " ";

        quizFieldBoxShadow +=
          (field_item.options["quiz-answer-field-box-shadow-color"]
            ? field_item.options["quiz-answer-field-box-shadow-color"]
            : "rgba(0,0,0, 0.35)") + " ";
      }

      let quizOptionsLayout = isValuePresent(field_item.options["quiz-options-layout"])
        ? field_item.options["quiz-options-layout"]
        : element.options["quiz-options-layout"] || undefined

      let quizOptionsVerticalSpacing = isValuePresent(field_item.options["quiz-options-vertical-spacing"])
        ? field_item.options["quiz-options-vertical-spacing"]
        : element.options["quiz-options-vertical-spacing"] || variant.options["quiz-options-vertical-spacing"] || 10

      let quizOptionsHorizontalSpacing = isValuePresent(field_item.options["quiz-options-horizontal-spacing"])
        ? field_item.options["quiz-options-horizontal-spacing"]
        : element.options["quiz-options-horizontal-spacing"] || variant.options["quiz-options-horizontal-spacing"] || 10

      let quizOptionVisualSpacing = field_item.options["quiz-option-visual-spacing"] || element.options["quiz-option-visual-spacing"] || variant.options["quiz-option-visual-spacing"] || 15;

      Object.values(field_item.field_options).forEach((option) => {
        desktopStyles += `
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-image-box {
            ${option.label ? '': 'width: 100% !important;'}
          }

          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-option-color,
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-option-emoji,
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-option-icon,
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-option-letter {
            ${(quizVisualPlacement == "left") && quizOptionVisualSpacing ? `margin: ${quizOptionVisualSpacing}px !important;` : ''}
            ${quizVisualPlacement == "centered" && quizOptionVisualSpacing ? `margin-bottom: ${quizOptionVisualSpacing}px !important; margin-top: ${quizOptionVisualSpacing}px !important;` : ''}
            ${quizVisualPlacement == "centered" && quizOptionWidth == "auto" && !option.label && quizOptionVisualSpacing ? `margin-left: ${quizOptionVisualSpacing}px !important; margin-right: ${quizOptionVisualSpacing}px !important;` : ''}
          }

          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-visual-box[data-visual-type="image"],
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-visual-box[data-visual-type="color"],
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-visual-box[data-visual-type="icon"],
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-visual-box[data-visual-type="emoji"] {
            ${!option.label ? 'margin-left: auto; margin-right: auto;' : ''}
          }
        `
      })

      let quizOptionBorderPlacement = isValuePresent(field_item.options["quiz-option-border-placement"])
        ? field_item.options["quiz-option-border-placement"]
        : element.options["quiz-option-border-placement"] || variant.options["quiz-option-border-placement"] || "on_option";

      let optionSelectedStyle = field_item.options["quiz-selected-option-style"] || element.options["quiz-selected-option-style"] || variant.options["quiz-selected-option-style"] || 'transparent';

      let quizOptionBorderColor = field_item.options["quiz-option-border-color"] || element.options["quiz-option-border-color"] || variant.options["quiz-option-border-color"] || "#bdc3c7";
      let quizSelectedOptionBorderColor = field_item.options["quiz-selected-option-border-color"] || element.options["quiz-selected-option-border-color"] || variant.options["quiz-selected-option-border-color"] || quizOptionBorderColor;

      let quizContentPlacement;
      if (field_item.options["quiz-content-placement"] == "below") {
        quizContentPlacement = "column-reverse";
      } else if (field_item.options["quiz-content-placement"] == "left") {
        quizContentPlacement = "row";
      } else if (field_item.options["quiz-content-placement"] == "right") {
        quizContentPlacement = "row-reverse";
      } else if (field_item.options["quiz-content-placement"] == "above") {
        quizContentPlacement = "column";
      } else if (element.options["quiz-content-placement"] == "below") {
        quizContentPlacement = "column-reverse";
      } else if (element.options["quiz-content-placement"] == "left") {
        quizContentPlacement = "row";
      } else if (element.options["quiz-content-placement"] == "right") {
        quizContentPlacement = "row-reverse";
      } else {
        quizContentPlacement = "column";
      }

      let quizContentWidth = isValuePresent(field_item.options["quiz-content-width"])
        ? field_item.options["quiz-content-width"]
        : element.options["quiz-content-width"];

      let quizOptionTextAlignment = isValuePresent(field_item.options["quiz-option-text-alignment"])
        ? field_item.options["quiz-option-text-alignment"]
        : element.options["quiz-option-text-alignment"]

      let quizAnswerFieldSize = isValuePresent(field_item.options["quiz-answer-field-size"])
        ? field_item.options["quiz-answer-field-size"]
        : element.options["quiz-answer-field-size"]

      let quizAnswerCalculatedWidth;
      if (isValuePresent(field_item.options["quiz-answer-width"]) && field_item.options["quiz-answer-width"] == "custom") {
        quizAnswerCalculatedWidth = `width: ${field_item.options["quiz-answer-width-value"]}px; max-width: ${field_item.options["quiz-answer-width-value"]}px;`;
      } else if (isValuePresent(element.options["quiz-answer-width"]) && element.options["quiz-answer-width"] == "custom") {
        quizAnswerCalculatedWidth = `width: ${element.options["quiz-answer-width-value"]}px; max-width: ${element.options["quiz-answer-width-value"]}px;`;
      }

      let quizAnswerFieldSizeValue = isValuePresent(field_item.options["quiz-answer-field-size-value"]) && field_item.options["quiz-answer-field-size"] == 'custom'
        ? field_item.options["quiz-answer-field-size-value"]
        : element.options["quiz-answer-field-size-value"]

      let quizAnswerFieldFont = field_item.options["quiz-answer-field-font"] || element.options["quiz-answer-field-font"]
      let quizAnswerFieldFontColor = field_item.options["quiz-answer-field-text-color"] || element.options["quiz-answer-field-text-color"]
      let quizAnswerFieldBackgroundColor = field_item.options["quiz-answer-field-background-color"] || element.options["quiz-answer-field-background-color"]
      let quizAnswerFieldBorderStyle = field_item.options["quiz-answer-field-border-style"] || element.options["quiz-answer-field-border-style"]
      let quizAnswerFieldBorderColor = field_item.options["quiz-answer-field-border-color"] || element.options["quiz-answer-field-border-color"]

      let quizLabelColor = field_item.options["quiz-label-color"] || element.options["quiz-label-color"];
      let quizFieldLabelFontSize = field_item.options["quiz-label-font-size"] || element.options["quiz-label-font-size"];
      let quizFieldLabelFontFamily = field_item.options["quiz-label-font-family"] || element.options["quiz-label-font-family"];
      let quizFieldLabelFontWeight = field_item.options["quiz-label-font-weight"] || element.options["quiz-label-font-weight"];
      let quizFieldLabelFontColor = field_item.options["quiz-label-font-color"] || element.options["quiz-label-font-color"];

      let quizLoadingSpinnerSize = isValuePresent(field_item.options["quiz-loading-spinner-size"])
        ? field_item.options["quiz-loading-spinner-size"]
        : isValuePresent(element.options["quiz-loading-spinner-size"])
          ? element.options["quiz-loading-spinner-size"]
          : isValuePresent(variant.options["quiz-loading-spinner-size"])
            ? variant.options["quiz-loading-spinner-size"]
            : 48;

      let quizLoadingBarBackgroundColor = isValuePresent(field_item.options["quiz-loading-bar-background-color"])
        ? field_item.options["quiz-loading-bar-background-color"]
        : isValuePresent(element.options["quiz-loading-bar-background-color"])
          ? element.options["quiz-loading-bar-background-color"]
          : isValuePresent(variant.options["quiz-loading-bar-background-color"])
            ? variant.options["quiz-loading-bar-background-color"]
            : undefined;

      let quizLoadingBarInnerBackgroundColor = isValuePresent(field_item.options["loading-background-color"])
        ? field_item.options["loading-background-color"]
        : isValuePresent(element.options["loading-background-color"])
          ? element.options["loading-background-color"]
          : isValuePresent(variant.options["quiz-loading-bar-inner-background-color"])
            ? variant.options["quiz-loading-bar-inner-background-color"]
            : undefined;

      let quizLoadingBorderStyle = isValuePresent(field_item.options["quiz-loading-border-style"])
        ? field_item.options["quiz-loading-border-style"]
        : isValuePresent(element.options["quiz-loading-border-style"])
          ? element.options["quiz-loading-border-style"]
          : isValuePresent(variant.options["quiz-loading-border-style"])
            ? variant.options["quiz-loading-border-style"]
            : "none";

      let quizLoadingBorderColor = isValuePresent(field_item.options["loading-border-color"])
        ? field_item.options["loading-border-color"]
        : isValuePresent(element.options["loading-border-color"])
          ? element.options["loading-border-color"]
          : isValuePresent(variant.options["quiz-loading-border-color"])
            ? variant.options["quiz-loading-border-color"]
            : undefined;

      let quizLoadingBorderWidthLeft = isValuePresent(field_item.options["quiz-loading-border-width-left"])
        ? field_item.options["quiz-loading-border-width-left"]
        : isValuePresent(element.options["quiz-loading-border-width-left"])
          ? element.options["quiz-loading-border-width-left"]
          : isValuePresent(variant.options["quiz-loading-border-width-left"])
            ? variant.options["quiz-loading-border-width-left"]
            : undefined;

      let quizLoadingBorderWidthRight = isValuePresent(field_item.options["quiz-loading-border-width-right"])
        ? field_item.options["quiz-loading-border-width-right"]
        : isValuePresent(element.options["quiz-loading-border-width-right"])
          ? element.options["quiz-loading-border-width-right"]
          : isValuePresent(variant.options["quiz-loading-border-width-right"])
            ? variant.options["quiz-loading-border-width-right"]
            : undefined;

      let quizLoadingBorderWidthBottom = isValuePresent(field_item.options["quiz-loading-border-width-bottom"])
        ? field_item.options["quiz-loading-border-width-bottom"]
        : isValuePresent(element.options["quiz-loading-border-width-bottom"])
          ? element.options["quiz-loading-border-width-bottom"]
          : isValuePresent(variant.options["quiz-loading-border-width-bottom"])
            ? variant.options["quiz-loading-border-width-bottom"]
            : undefined;

      let quizLoadingBorderWidthTop = isValuePresent(field_item.options["quiz-loading-border-width-top"])
        ? field_item.options["quiz-loading-border-width-top"]
        : isValuePresent(element.options["quiz-loading-border-width-top"])
          ? element.options["quiz-loading-border-width-top"]
          : isValuePresent(variant.options["quiz-loading-border-width-top"])
            ? variant.options["quiz-loading-border-width-top"]
            : undefined;

      let calculatedQuizLoadingOuterRadius = "";

      // Helper to get custom values for a given source (field_item, element, variant)
      function getCustomRadiusValues(source) {
        return ["top-left", "top-right", "bottom-right", "bottom-left"].map((side) => {
          let val = isValuePresent(source?.options?.["quiz-loading-outer-radius-" + side])
            ? source.options["quiz-loading-outer-radius-" + side]
            : undefined;
          return _.isNil(val) == false ? val : "4";
        });
      }

      // 1. If field_item has custom setting, apply custom values
      if (field_item.options["quiz-loading-outer-radius"] === "custom") {
        calculatedQuizLoadingOuterRadius = getCustomRadiusValues(field_item).map(v => `${v}px`).join(" ");
      }
      // 2. If field_item has other setting, apply it
      else if (isValuePresent(field_item.options["quiz-loading-outer-radius"])) {
        if (field_item.options["quiz-loading-outer-radius"] === "cf-not-rounded") {
          calculatedQuizLoadingOuterRadius = "0px";
        } else if (field_item.options["quiz-loading-outer-radius"] === "cf-slightly-rounded") {
          calculatedQuizLoadingOuterRadius = "4px";
        } else if (field_item.options["quiz-loading-outer-radius"] === "cf-fully-rounded") {
          calculatedQuizLoadingOuterRadius = "100px";
        }
      }
      // 3. If field_item has no corner setting, apply element custom setting and custom values
      else if (element.options["quiz-loading-outer-radius"] === "custom") {
        calculatedQuizLoadingOuterRadius = getCustomRadiusValues(element).map(v => `${v}px`).join(" ");
      }
      // 4. If element has other setting, apply it
      else if (isValuePresent(element.options["quiz-loading-outer-radius"])) {
        if (element.options["quiz-loading-outer-radius"] === "cf-not-rounded") {
          calculatedQuizLoadingOuterRadius = "0px";
        } else if (element.options["quiz-loading-outer-radius"] === "cf-slightly-rounded") {
          calculatedQuizLoadingOuterRadius = "4px";
        } else if (element.options["quiz-loading-outer-radius"] === "cf-fully-rounded") {
          calculatedQuizLoadingOuterRadius = "100px";
        }
      }
      // 5. If element has no corner setting, apply variant custom setting and custom values
      else if (variant.options["quiz-loading-outer-radius"] === "custom") {
        calculatedQuizLoadingOuterRadius = getCustomRadiusValues(variant).map(v => `${v}px`).join(" ");
      }
      // 6. If variant has other setting, apply it
      else if (isValuePresent(variant.options["quiz-loading-outer-radius"])) {
        if (variant.options["quiz-loading-outer-radius"] === "cf-not-rounded") {
          calculatedQuizLoadingOuterRadius = "0px";
        } else if (variant.options["quiz-loading-outer-radius"] === "cf-slightly-rounded") {
          calculatedQuizLoadingOuterRadius = "4px";
        } else if (variant.options["quiz-loading-outer-radius"] === "cf-fully-rounded") {
          calculatedQuizLoadingOuterRadius = "100px";
        }
      }
      // 7. If variant has no setting, apply defaults
      else {
        calculatedQuizLoadingOuterRadius = "4px";
      }

      desktopStyles += `
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-image-box {
          ${quizImagePlacementWidth ? `width: ${quizImagePlacementWidth} !important;` : ""}
          ${quizImagePlacement == "left" ? "flex-shrink: 0;" : ""}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-content-answers-wrapper[data-field-id="${field_item.id}"] {
          ${quizContentPlacement ? `flex-direction: ${quizContentPlacement} !important;` : ''}
          ${quizContentWidth ? `max-width: ${quizContentWidth}px !important;` : ''}
          margin-left: auto;
          margin-right: auto;
        }
        ${quizButtonsContentContainment(
          field_item.id,
          quizContentWidth,
          options["quiz-buttons-container-width"]
        )}

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="image"] {
          ${quizImagePlacement == "centered" ? 'flex-direction: column;' : ''}
          ${quizImagePlacement == "left" ? 'flex-wrap: nowrap; gap: 10px;' : 'flex-wrap: wrap;'}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-image {
          ${quizImagePlacement == "left" ? 'display: block;' : 'display: inline;'}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] {
          overflow: hidden;
          ${quizOptionsVerticalSpacing ? `margin-top: ${quizOptionsVerticalSpacing}px !important; margin-bottom: ${quizOptionsVerticalSpacing}px !important;` : ''}
          ${options["cf-content-alignment"] == "cf-left" ? `margin-right: ${quizOptionsHorizontalSpacing*2}px !important;` : ''}
          ${options["cf-content-alignment"] == "cf-right" ? `margin-left: ${quizOptionsHorizontalSpacing*2}px !important;` : ''}
          ${options["cf-content-alignment"] == "cf-center" || !options["cf-content-alignment"] ? `margin-left: ${quizOptionsHorizontalSpacing}px !important; margin-right: ${quizOptionsHorizontalSpacing}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-quiz-answers-wrapper {
          ${quizOptionsLayout == "responsive" ? 'flex-direction: row;' : ''}
          ${quizOptionsLayout == "stacked" ? 'flex-direction: column;' : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-quiz-answers-outer-wrapper {
          ${!field_item.options["label-image"] ? 'display: block;' : field_item.options["label-image-placement"] == "below" ? 'display: block !important;' : field_item.options["label-image-placement"] ? 'display: flex !important;' : ''}
          ${field_item.options["label-image-placement"] == "left" ? 'flex-direction: row !important;' : ''}
          ${field_item.options["label-image-placement"] == "right" ? 'flex-direction: row-reverse !important;' : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-quiz-inner-wrapper {
          ${['left', 'right'].includes(field_item.options["label-image-placement"]) ? 'margin-top: 0px; margin-bottom: auto;' : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-quiz-answers-outer-wrapper img {
          ${['left', 'right'].includes(field_item.options["label-image-placement"]) ? 'max-width: 80%;' : ''}
          ${field_item.options["label-image-placement"] == 'left' ? 'margin-right: 30px;' : ''}
          ${field_item.options["label-image-placement"] == 'right' ? 'margin-left: 30px;' : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-quiz-label-image {
          ${field_item.options["label-image-width"] ? `width: ${field_item.options["label-image-width"]}px;` : 'width: fit-content;'}
          height: initial;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-loading-bar {
          ${quizLoadingBarBackgroundColor ? `background: ${quizLoadingBarBackgroundColor};` : ''}
          ${quizLoadingBorderStyle ? `border-style: ${quizLoadingBorderStyle};` : ''}
          ${quizLoadingBorderWidthLeft ? `border-left-width: ${quizLoadingBorderWidthLeft}px;` : ''}
          ${quizLoadingBorderWidthRight ? `border-right-width: ${quizLoadingBorderWidthRight}px;` : ''}
          ${quizLoadingBorderWidthBottom ? `border-bottom-width: ${quizLoadingBorderWidthBottom}px;` : ''}
          ${quizLoadingBorderWidthTop ? `border-top-width: ${quizLoadingBorderWidthTop}px;` : ''}
          ${calculatedQuizLoadingOuterRadius ? `border-radius: ${calculatedQuizLoadingOuterRadius};` : ''}
          ${quizLoadingBorderColor ? `border-color: ${quizLoadingBorderColor};` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-loading-bar:after {
          animation: ${field_item.options["auto-continue-delay"] || 5}s cf-quiz-loading-bar ease-in infinite;
          ${quizLoadingBarInnerBackgroundColor ? `background: ${quizLoadingBarInnerBackgroundColor};` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-loading-spinner::before {
          ${quizLoadingBorderColor ? `border-color: ${quizLoadingBorderColor};` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-loading-spinner {
          ${quizLoadingSpinnerSize ? `width: ${quizLoadingSpinnerSize}px !important; height: ${quizLoadingSpinnerSize}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-loading-bar,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-loading-spinner {
          ${field_item.options["loading-spacing"] ? `margin-top: ${field_item.options["loading-spacing"]}px !important; margin-bottom: ${field_item.options["loading-spacing"]}px !important; ` : 'margin-bottom: 30px !important; margin-top: 30px !important;'}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2 {
          ${quizAnswerCalculatedWidth ? quizAnswerCalculatedWidth : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-visual-box {
          ${quizVisualPlacementWidth ? `min-width: ${quizVisualPlacementWidth} !important;` : ""}
          ${quizVisualPlacement == "centered" ? `margin-right: unset;` : ''}
          ${quizVisualPlacement == "left" ? `margin-bottom: unset;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-color {
          ${quizOptionColorSize ? `width: ${quizOptionColorSize}px !important;` : ''}
          ${quizOptionColorSize ? `height: ${quizOptionColorSize}px !important;` : ''}
          color: transparent;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-color:empty {
          display: none;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="text"]::placeholder,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="date"]::placeholder,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="datetime-local"]::placeholder,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="email"]::placeholder,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="tel"]::placeholder,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="number"]::placeholder,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default textarea::placeholder,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default select::placeholder {
          ${_.isNil(quizAnswerFieldFontColor) == false ? `color: ${quizAnswerFieldFontColor} !important;` : ''}
          ${quizFieldFontWeight ? `font-weight: ${quizFieldFontWeight} !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="text"]:not(.cf-quiz-required),
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="date"]:not(.cf-quiz-required),
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="datetime-local"]:not(.cf-quiz-required),
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="email"]:not(.cf-quiz-required),
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="tel"]:not(.cf-quiz-required),
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="number"]:not(.cf-quiz-required),
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default textarea:not(.cf-quiz-required),
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default select:not(.cf-quiz-required) {
          ${quizFieldBoxShadow ? 'box-shadow: ' + quizFieldBoxShadow + ' !important;' : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default .cf-field-range .noUi-value {
          ${_.isNil(quizAnswerFieldFontColor) == false ? `color: ${quizAnswerFieldFontColor} !important; opacity: 1;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default .cf-field-range .noUi-tooltip {
          ${_.isNil(quizAnswerFieldFontColor) == false ? `color: ${quizAnswerFieldFontColor} !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default .cf-field-range .noUi-horizontal {
          ${quizAnswerFieldSize == 'custom' && _.isNil(quizAnswerFieldSizeValue) == false ? `height: ${quizAnswerFieldSizeValue}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default .cf-field-range .noUi-handle {
          ${quizAnswerFieldSize == 'custom' && _.isNil(quizAnswerFieldSizeValue) == false ? `height: ${parseInt(quizAnswerFieldSizeValue) + 10}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="text"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="date"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="datetime-local"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="email"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="tel"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="number"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default textarea,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default select {
          ${quizAnswerFieldSize == 'custom' && _.isNil(quizAnswerFieldSizeValue) == false ? `padding: ${customInputPaddingCalculated} !important; padding-right: 5px !important;` : `padding: ${regularInputPaddingCalculated} !important;`}
          ${quizFieldFontWeight ? `font-weight: ${quizFieldFontWeight} !important;` : ''}
          ${_.isNil(quizAnswerFieldFontColor) == false ? `color: ${quizAnswerFieldFontColor} !important;` : ''}
          ${_.isNil(quizFieldRadius) == false ? `border-radius: ${quizFieldRadius} !important;` : ''}
          ${_.isNil(quizAnswerFieldBackgroundColor) == false ? `background: ${quizAnswerFieldBackgroundColor} !important;` : ''}
          ${_.isNil(quizAnswerFieldBorderStyle) == false ? `border-style: ${quizAnswerFieldBorderStyle} !important;` : ''}
          ${_.isNil(quizAnswerFieldBorderColor) == false ? `border-color: ${quizAnswerFieldBorderColor} !important;` : ''}
          ${_.isNil(field_item.options["quiz-answer-field-border-width"]) == false ? 'border-width: ' + field_item.options["quiz-answer-field-border-width"] + 'px !important;' : ''}
          ${_.isNil(field_item.options["quiz-answer-field-border-width-left"]) == false ? 'border-left-width: ' + field_item.options["quiz-answer-field-border-width-left"] + 'px !important;' : ''}
          ${_.isNil(field_item.options["quiz-answer-field-border-width-right"]) == false ? 'border-right-width: ' + field_item.options["quiz-answer-field-border-width-right"] + 'px !important;' : ''}
          ${_.isNil(field_item.options["quiz-answer-field-border-width-top"]) == false ? 'border-top-width: ' + field_item.options["quiz-answer-field-border-width-top"] + 'px !important;' : ''}
          ${_.isNil(field_item.options["quiz-answer-field-border-width-bottom"]) == false ? 'border-bottom-width: ' + field_item.options["quiz-answer-field-border-width-bottom"] + 'px !important;' : ''}
          ${quizAnswerFieldSize != 'custom' ? `padding: ${largeInputPaddingCalculated} !important;` : ''}
          ${quizFieldFontSize ? `font-size: ${quizFieldFontSize}px !important;` : ''}
          ${quizAnswerFieldFont ? `font-family: ${quizAnswerFieldFont}, sans-serif !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="image"] .cf-quiz-option-label {
          padding: 10px;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="radio"] .cf-selection-options,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="checkbox"] .cf-selection-options {
          width: fit-content !important;
          text-align: left !important;
          ${quizContentAlignmentMargin ? quizContentAlignmentMargin : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-radio-option {
          ${quizOptionTextAlignment ? `text-align: ${quizOptionTextAlignment}` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-radio-option .cf-label {
          ${quizLabelColor ? `color: ${quizLabelColor} !important;` : ''}
          ${quizFieldLabelFontSize ? `font-size: ${quizFieldLabelFontSize}px !important;` : ''}
          ${quizFieldLabelFontFamily ? `font-family: ${quizFieldLabelFontFamily}, sans-serif !important;` : ''}
          ${quizFieldLabelFontWeight ? `font-weight: ${quizFieldLabelFontWeight} !important;` : ''}
          ${quizFieldLabelFontColor ? `color: ${quizFieldLabelFontColor} !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="radio_survey"] .cf-quiz-option-radio {
          border-color: ${quizOptionBorderColor} !important;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="radio_survey"].cf-option-selected .cf-quiz-option-radio {
          border-color: ${quizSelectedOptionBorderColor} !important;
          background: radial-gradient(circle, ${quizSelectedOptionBorderColor} 0 45%, #fff 46%) !important;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-label {
          ${quizOptionTextAlignment == 'center' ? `margin-left: auto !important; margin-right: auto !important; text-align: center !important;` : ''}
          ${quizOptionTextAlignment == 'left' ? `margin-left: 0px !important; margin-right: auto !important; text-align: left !important;` : ''}
          ${quizOptionTextAlignment == 'right' ? `margin-right: 0px !important; margin-left: auto !important; text-align: right !important;` : ''}
          ${quizOptionFontFamily && quizOptionFontFamily !== 'inherit' ? `font-family: ${quizOptionFontFamily}, sans-serif;` : ''}
          ${quizOptionFontWeight ? `font-weight: ${quizOptionFontWeight};` : ''}
          ${quizOptionFontSize ? `font-size: ${quizOptionFontSize}px;` : ''}
          ${quizOptionFontLineHeight ? `line-height: ${quizOptionFontLineHeight}px;` : ''}
          ${quizOptionFontColor ? `color: ${quizOptionFontColor};` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="color"] .cf-quiz-option-label,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="icon"] .cf-quiz-option-label,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="letter"] .cf-quiz-option-label,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="emoji"] .cf-quiz-option-label {
          ${field_item.label && quizVisualPlacement == "left" && quizOptionWidth == "auto" ? 'padding-right: 10px;' : ''}
          ${field_item.label && quizVisualPlacement == "centered" ? 'padding-left: 10px; padding-right: 10px;' : ''}
          ${field_item.label && quizVisualPlacement == "centered" ? 'margin-bottom: 15px;' : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-letter {
          ${quizOptionVisualColor ? `border: 2px solid ${quizOptionVisualColor} !important;` : ''}
          ${quizOptionVisualColor ? `background-color: ${quizOptionVisualColor}14 !important;` : ''}
          ${quizOptionVisualColor ? `color: ${quizOptionVisualColor} !important;` : ""}
          ${quizOptionVisualFontSize ? `font-size: ${quizOptionVisualFontSize*0.77}px !important;` : ""}
          width: ${quizOptionVisualFontSize * 1.5}px !important;
          height: ${quizOptionVisualFontSize * 1.5}px !important;
        }


        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"]:hover .cf-quiz-option-letter {
          ${quizHoverOptionVisualColor ? `border: 2px solid ${quizHoverOptionVisualColor} !important;` : ''}
          ${quizHoverOptionVisualColor ? `background-color: ${quizHoverOptionVisualColor}14 !important;` : ''}
          ${quizHoverOptionVisualColor ? `color: ${quizHoverOptionVisualColor} !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"].cf-option-selected {
          ${quizSelectedOptionBackgroundColor && optionSelectedStyle == "custom" ? `background: ${quizSelectedOptionBackgroundColor} !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-icon .svg-inline--fa {
          ${quizOptionVisualFontSize ? `font-size: ${quizOptionVisualFontSize}px;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-emoji,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-icon svg {
          ${quizOptionVisualColor ? `color: ${quizOptionVisualColor};` : ''}
          ${quizOptionVisualFontSize ? `font-size: ${quizOptionVisualFontSize}px;` : ''}
        }


        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"]:hover .cf-quiz-option-emoji,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"]:hover .cf-quiz-option-icon svg {
          ${quizHoverOptionVisualColor ? `color: ${quizHoverOptionVisualColor} !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-image,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-image-svg {
          ${quizOptionImageWidth ? `width: ${quizOptionImageWidth}px !important;` : 'max-width: 250px;'}
          ${quizOptionImageHeight ? `height: ${quizOptionImageHeight}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="survey"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="radio_survey"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="image"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="color"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="icon"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="letter"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="emoji"] {
          ${quizOptionWidth ? `width: ${quizOptionWidth};` : ''}
          ${quizOptionWidth ? `max-width: 100%;` : ''}
          ${quizOptionBackgroundColor ? `background: ${quizOptionBackgroundColor};` : ''}
          ${quizOptionBoxShadow ? `box-shadow: ${quizOptionBoxShadow} !important;` : ''}
          ${quizOptionHeightAuto(field_item) ? `justify-content: center;` : ''}
          ${quizOptionHeightAuto(field_item) ? `align-content: center;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="survey"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="color"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="icon"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="letter"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="emoji"] {
          ${quizVisualPlacement == "left" ? 'flex-wrap: nowrap;' : 'flex-wrap: wrap;'}
          ${quizVisualPlacement == "left" ? 'gap: 0px;' : 'gap: 5px;'}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"].cf-option-selected .cf-quiz-visual-box[data-visual-type="image"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"].cf-option-selected .cf-quiz-visual-box[data-visual-type="color"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"].cf-option-selected .cf-quiz-visual-box[data-visual-type="icon"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"].cf-option-selected .cf-quiz-visual-box[data-visual-type="emoji"] {
          ${selectedOptionBorderStyles(field_item, quizOptionBorderPlacement == "on_visual" )}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="survey"].cf-option-selected,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="radio_survey"].cf-option-selected,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="color"].cf-option-selected,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="icon"].cf-option-selected,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="letter"].cf-option-selected,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="emoji"].cf-option-selected {
          ${selectedOptionBorderStyles(field_item, quizOptionBorderPlacement == "on_option" )}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="image"].cf-option-selected {
          ${selectedOptionBorderStyles(field_item, true)}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="letter"].cf-option-selected .cf-quiz-option-letter {
          ${quizSelectedOptionFontColor && optionSelectedStyle == "custom" ? `color: ${quizSelectedOptionFontColor};` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"].cf-option-selected .cf-quiz-option-label {
          ${quizSelectedOptionFontColor && optionSelectedStyle == "custom" ? `color: ${quizSelectedOptionFontColor};` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"].cf-option-selected .cf-quiz-option-icon svg {
          ${quizSelectedOptionFontColor && optionSelectedStyle == "custom" ? `color: ${quizSelectedOptionFontColor};` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"].cf-option-selected .cf-quiz-option-letter {
          ${quizSelectedOptionFontColor ? `border: 2px solid ${quizSelectedOptionFontColor};` : ''}
          ${quizSelectedOptionFontColor ? `background-color: ${quizSelectedOptionFontColor}14;` : ''}
          ${quizSelectedOptionFontColor ? `color: ${quizSelectedOptionFontColor};` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-visual-box[data-visual-type="image"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-visual-box[data-visual-type="color"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-visual-box[data-visual-type="icon"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-visual-box[data-visual-type="emoji"] {
          ${optionBorderStyles(field_item, quizOptionBorderPlacement == "on_visual" )}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="survey"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="radio_survey"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="color"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="icon"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="letter"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="emoji"] {
          ${optionBorderStyles(field_item, quizOptionBorderPlacement == "on_option")}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="image"] {
          ${optionBorderStyles(field_item, true)}
        }


        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-visual-box[data-visual-type="image"]:hover,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-visual-box[data-visual-type="color"]:hover,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-visual-box[data-visual-type="icon"]:hover,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-visual-box[data-visual-type="emoji"]:hover {
          ${hoverOptionStyles(field_item, quizOptionBorderPlacement == "on_visual")}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="survey"]:hover,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="radio_survey"]:hover,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="color"]:hover,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="icon"]:hover,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="letter"]:hover,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="emoji"]:hover {
          ${hoverOptionStyles(field_item, quizOptionBorderPlacement == "on_option" )}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="image"]:hover {
          ${hoverOptionStyles(field_item, true)}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"]:hover .cf-quiz-option-label {
          ${quizHoverOptionFontColor ? `color: ${quizHoverOptionFontColor} !important;` : ''}
        }
      `;
    })

    let quizMaxWidthElementMobile = "";
    if (
      options["quiz-max-width-style-mobile"] == "custom" &&
      options["quiz-max-width-value-mobile"]
    ) {
      quizMaxWidthElementMobile = `${options["quiz-max-width-value-mobile"]}px`;
    } else if (options["quiz-max-width-style"] == "full") {
      quizMaxWidthElementMobile = "100%";
    }

    let quizQuestionFontSizeMobile;
    if (
      options["quiz-question-font-size-mobile"] &&
      options["quiz-question-font-size-mobile"] !== "theme"
    ) {
      quizQuestionFontSizeMobile = options["quiz-question-font-size-mobile"];
    }

    let quizQuestionLineHeightMobile;
    if (options["quiz-question-font-line-height-mobile"]) {
      quizQuestionLineHeightMobile =
        options["quiz-question-font-line-height-mobile"];
    }

    let quizDescriptionFontSizeMobile;
    if (
      options["quiz-description-font-size-mobile"] &&
      options["quiz-description-font-size-mobile"] !== "theme"
    ) {
      quizDescriptionFontSizeMobile =
        options["quiz-description-font-size-mobile"];
    }

    let quizDescriptionLineHeightMobile;
    if (options["quiz-description-font-line-height-mobile"]) {
      quizDescriptionLineHeightMobile =
        options["quiz-description-font-line-height-mobile"];
    }

    ////////

    let quizContentAlignmentMobile = "";
    let quizContentAlignmentMarginMobile = "";
    switch (options["cf-content-alignment-mobile"]) {
      case "cf-left":
        quizContentAlignmentMarginMobile = "margin-right: auto; margin-left: unset;";
        quizContentAlignmentMobile =
          "text-align: left !important; justify-content: flex-start !important; align-content: flex-start !important;";
        break;
      case "cf-center":
        quizContentAlignmentMarginMobile = "margin-right: auto; margin-left: auto;";
        quizContentAlignmentMobile =
          "text-align: center !important; justify-content: center !important; align-content: center !important;";
        break;
      case "cf-right":
        quizContentAlignmentMarginMobile = "margin-left: auto; margin-right: unset;";
        quizContentAlignmentMobile =
          "text-align: right !important; justify-content: flex-end !important; align-content: flex-end !important;";
        break;
    }

    let quizQuestionDistanceFromProgressMobile =
      options["quiz-question-distance-from-progress-mobile"];

    let quizQuestionSpacingMobile =
      options["quiz-question-spacing-mobile"] ||
      variant.options["quiz-question-spacing-mobile"] ||
      undefined;

    let quizButtonWidthMobile;
    if (options["quiz-button-width-mobile"] == "cf-button-slim") {
      quizButtonWidthMobile = "max-width: fit-content !important;"
    } else if (options["quiz-button-width-mobile"] == "cf-button-mid") {
      quizButtonWidthMobile = "max-width: 250px !important;"
    } else if (options["quiz-button-width-mobile"] == "cf-full-width") {
      quizButtonWidthMobile = "max-width: 100% !important;"
    } else if (
      options["quiz-button-width-mobile"] == "custom" &&
      options["quiz-button-width-value-mobile"]
    ) {
      quizButtonWidthMobile =
        "max-width: " +
        options["quiz-button-width-value-mobile"] +
        "px !important;";
    }

    let quizProgressOuterWidthMobile = options["quiz-progress-outer-width-mobile"] || undefined;

    // prettier-ignore
    let mobileStyles =
    `/* mobile styles */
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-element {
      ${quizMaxWidthElementMobile ? `max-width: ${quizMaxWidthElementMobile};` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question .cf-progress-outer {
      ${quizProgressOuterWidthMobile ? `width: ${quizProgressOuterWidthMobile}px !important;` : 'width: 100% !important;'}
      ${quizProgressOuterWidthMobile ? `flex-basis: ${quizProgressOuterWidthMobile}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question .cf-progress {
      ${quizQuestionDistanceFromProgressMobile ? `margin-bottom: ${quizQuestionDistanceFromProgressMobile}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-description,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-label {
      ${quizQuestionSpacingMobile ? `margin-bottom: ${quizQuestionSpacingMobile}px;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-answers-wrapper {
      ${quizQuestionSpacingMobile ? `margin: ${quizQuestionSpacingMobile}px 0px;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-button {
      ${quizButtonWidthMobile ? quizButtonWidthMobile : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-buttons-wrapper {
      ${quizButtonSpacingTopMobile ? `margin-top: ${quizButtonSpacingTopMobile}px !important;` : ''}
      ${quizButtonsContainerWidthMobile ? `max-width: ${quizButtonsContainerWidthMobile}; ${quizButtonContainerMargin || 'margin-left: auto; margin-right: auto;'}` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-buttons-inner {
      ${quizButtonsContainerWidthMobile ? `max-width: ${quizButtonsContainerWidthMobile};` : ''}
    }

    ${hasConstrainedHeightMobile ? `
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-inner-wrapper {
      ${quizHeightCss(options["quiz-height-mobile"], expandToBrowserMobile)}
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar {
      position: sticky;
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar.cf-quiz-sticky-bottom {
      margin-top: auto;
    }
    ` : options["quiz-expand-to-browser-height-mobile"] === "false" && expandToBrowser ? `
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-inner-wrapper {
      height: auto;
      overflow: visible;
    }
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar.cf-quiz-sticky-bottom {
      margin-top: 0;
    }
    ` : ""}

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-answers-wrapper,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-buttons-wrapper {
      ${quizContentAlignmentMobile ? quizContentAlignmentMobile : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-buttons-wrapper,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-buttons-inner,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-sticky-bar.cf-quiz-sticky-bottom {
      ${quizButtonAlignment}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-description, #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-description * {
      ${quizDescriptionFontSizeMobile ? `font-size: ${quizDescriptionFontSizeMobile}px;` : ''}
      ${quizDescriptionLineHeightMobile ? `line-height: ${quizDescriptionLineHeightMobile}px;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-label, #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-label * {
      ${quizQuestionFontSizeMobile ? `font-size: ${quizQuestionFontSizeMobile}px;` : ''}
      ${quizQuestionLineHeightMobile ? `line-height: ${quizQuestionLineHeightMobile}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h1,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h2,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h3,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h4,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h5,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message p,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message span {
      ${options["quiz-progress-text-size-mobile"] ? `font-size: ${options["quiz-progress-text-size-mobile"]}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question .cf-quiz-progress-inner {
      ${quizProgressLabelFormat !== "box" && options['quiz-progress-height-mobile'] ? `min-height: ${options['quiz-progress-height-mobile']}px !important;` : ''}
      ${quizProgressLabelFormat == "box" && options['quiz-progress-inner-padding-mobile'] ? `padding: ${options['quiz-progress-inner-padding-mobile']}px !important;` : ''}
    }
    `;

    // INDIVIDUAL OPTIONS STYLES
    // prettier-ignore
    Object.values(sorted_fields).forEach((field_item) => {
      let quizOptionWidthMobile = "";
      if (
        field_item.options["quiz-option-width-style-mobile"] == "custom" &&
        field_item.options["quiz-option-width-value-mobile"]
      ) {
        quizOptionWidthMobile = `${field_item.options["quiz-option-width-value-mobile"]}px`;
      } else if (field_item.options["quiz-option-width-style-mobile"] == "regular") {
        quizOptionWidthMobile = "150px";
      } else if (field_item.options["quiz-option-width-style-mobile"] == "full") {
        quizOptionWidthMobile = "100%";
      } else if (field_item.options["quiz-option-width-style-mobile"] == "auto") {
        quizOptionWidthMobile = "auto";
      } else if (
        element.options["quiz-option-width-style-mobile"] == "custom" &&
        element.options["quiz-option-width-value-mobile"]
      ) {
        quizOptionWidthMobile = `${element.options["quiz-option-width-value-mobile"]}px`;
      } else if (element.options["quiz-option-width-style-mobile"] == "regular") {
        quizOptionWidthMobile = "300px";
      } else if (element.options["quiz-option-width-style-mobile"] == "full") {
        quizOptionWidthMobile = "100%";
      } else if (element.options["quiz-option-width-style-mobile"] == "auto") {
        quizOptionWidthMobile = "auto";
      } else if (
        variant.options["quiz-option-width-style-mobile"] == "custom" &&
        variant.options["quiz-option-width-value-mobile"]
      ) {
        quizOptionWidthMobile = `${variant.options["quiz-option-width-value-mobile"]}px`;
      } else if (variant.options["quiz-option-width-style-mobile"] == "regular") {
        quizOptionWidthMobile = "300px";
      } else if (variant.options["quiz-option-width-style-mobile"] == "full") {
        quizOptionWidthMobile = "-webkit-fill-available";
      } else {
        quizOptionWidthMobile = resolveQuizOptionWidth(field_item);
      }

      let quizOptionFontSizeMobile;
      if (
        field_item.options["quiz-option-font-size-mobile"] &&
        field_item.options["quiz-option-font-size-mobile"] !== "theme"
      ) {
        quizOptionFontSizeMobile = field_item.options["quiz-option-font-size-mobile"];
      } else if (
        element.options["quiz-option-font-size-mobile"] &&
        element.options["quiz-option-font-size-mobile"] !== "theme"
      ) {
        quizOptionFontSizeMobile = element.options["quiz-option-font-size-mobile"];
      }

      let quizOptionFontLineHeightMobile;
      if (
        field_item.options["quiz-option-font-line-height-mobile"] &&
        field_item.options["quiz-option-font-line-height-mobile"] !== "theme"
      ) {
        quizOptionFontLineHeightMobile =
          field_item.options["quiz-option-font-line-height-mobile"];
      } else if (
        element.options["quiz-option-font-line-height-mobile"] &&
        element.options["quiz-option-font-line-height-mobile"] !== "theme"
      ) {
        quizOptionFontLineHeightMobile = element.options["quiz-option-font-line-height-mobile"];
      }

      let quizImagePlacementMobile = isValuePresent(field_item.options["quiz-image-placement-mobile"])
        ? field_item.options["quiz-image-placement-mobile"]
        : element.options["quiz-image-placement-mobile"] || variant.options["quiz-image-placement-mobile"];

      let quizVisualPlacementMobile = isValuePresent(field_item.options["quiz-visual-placement-mobile"])
        ? field_item.options["quiz-visual-placement-mobile"]
        : element.options["quiz-visual-placement-mobile"] || variant.options["quiz-visual-placement-mobile"] || 'centered';

      let quizOptionVisualFontSizeMobile = isValuePresent(field_item.options["quiz-option-visual-font-size-mobile"])
        ? field_item.options["quiz-option-visual-font-size-mobile"]
        : element.options["quiz-option-visual-font-size-mobile"] || undefined;

      let quizOptionImageWidthMobile = isValuePresent(field_item.options["quiz-option-image-width-mobile"])
        ? field_item.options["quiz-option-image-width-mobile"]
        : element.options["quiz-option-image-width-mobile"] || 110;

      let quizOptionImageHeightMobile = isValuePresent(field_item.options["quiz-option-image-height-mobile"])
        ? field_item.options["quiz-option-image-height-mobile"]
        : element.options["quiz-option-image-height-mobile"] || quizOptionImageWidthMobile;

      let quizImagePlacementWidthMobile;
      if (quizImagePlacementMobile == "centered" || !field_item.label) {
        quizImagePlacementWidthMobile = "100%";
      } else if (quizImagePlacementMobile == "left") {
        quizImagePlacementWidthMobile = `${quizOptionImageWidthMobile}px`;
      }

      let quizVisualPlacementWidthMobile;
      if (quizVisualPlacementMobile == "centered") {
        quizVisualPlacementWidthMobile = "100%";
      } else if (quizVisualPlacementMobile == "left") {
        quizVisualPlacementWidthMobile = quizOptionVisualFontSizeMobile
          ? `${parseInt(quizOptionVisualFontSizeMobile) * 0.6}%`
          : "10%";
      }

      let quizOptionColorSizeMobile = isValuePresent(field_item.options["quiz-option-color-size-mobile"])
        ? field_item.options["quiz-option-color-size-mobile"]
        : element.options["quiz-option-color-size-mobile"] || undefined;

      let quizFieldFontSizeMobile;
      if (field_item.options["quiz-answer-field-font-size-mobile"]) {
        quizFieldFontSizeMobile = field_item.options["quiz-answer-field-font-size-mobile"];
      } else if (element.options["quiz-answer-field-font-size-mobile"]) {
        quizFieldFontSizeMobile = element.options["quiz-answer-field-font-size-mobile"];
      }

      let quizConsideredFontSizeMobile =
        quizFieldFontSizeMobile ||
        field_item.options["quiz-answer-field-font-size"] ||
        variant.options["field-font-size-mobile"] ||
        element.options["field-font-size-mobile"] ||
        field_item.options["field-font-size"] ||
        variant.options["field-font-size"] ||
        15;

      let quizOptionsLayoutMobile = isValuePresent(field_item.options["quiz-options-layout-mobile"])
        ? field_item.options["quiz-options-layout-mobile"]
        : element.options["quiz-options-layout-mobile"];

      let quizOptionVisualSpacingMobile = isValuePresent(field_item.options["quiz-option-visual-spacing-mobile"])
        ? field_item.options["quiz-option-visual-spacing-mobile"]
        : element.options["quiz-option-visual-spacing-mobile"] || variant.options["quiz-option-visual-spacing-mobile"] || 15;

      let quizOptionsHorizontalSpacingMobile = isValuePresent(field_item.options["quiz-options-horizontal-spacing-mobile"])
        ? field_item.options["quiz-options-horizontal-spacing-mobile"]
        : element.options["quiz-options-horizontal-spacing-mobile"] || variant.options["quiz-options-horizontal-spacing-mobile"] || field_item.options["quiz-options-horizontal-spacing"] || variant.options["quiz-options-horizontal-spacing"] || 10

      let quizOptionsVerticalSpacingMobile = isValuePresent(field_item.options["quiz-options-vertical-spacing-mobile"])
        ? field_item.options["quiz-options-vertical-spacing-mobile"]
        : element.options["quiz-options-vertical-spacing-mobile"] || variant.options["quiz-options-vertical-spacing-mobile"] || field_item.options["quiz-options-vertical-spacing"] || variant.options["quiz-options-vertical-spacing"] || undefined

      Object.values(field_item.field_options).forEach((option) => {
        mobileStyles += `
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-option-color,
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-option-emoji,
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-option-icon,
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-option-id="${option.id}"] .cf-quiz-option-letter {
            ${quizVisualPlacementMobile == "left" && quizOptionVisualSpacingMobile ? `margin: ${quizOptionVisualSpacingMobile}px !important;` : ''}
            ${quizVisualPlacementMobile == "centered" && quizOptionVisualSpacingMobile ? `margin: ${quizOptionVisualSpacingMobile}px auto ${quizOptionVisualSpacingMobile}px auto !important;`  : ''}
            ${quizVisualPlacementMobile == "centered" && quizOptionWidthMobile == "auto" && !option.label && quizOptionVisualSpacingMobile ? `margin-left: ${quizOptionVisualSpacingMobile}px !important; margin-right: ${quizOptionVisualSpacingMobile}px !important;` : ''}
          }
        `
      })

      let quizContentPlacementMobile;
      if (field_item.options["quiz-content-placement-mobile"] == "below") {
        quizContentPlacementMobile = "column-reverse";
      } else if (field_item.options["quiz-content-placement-mobile"] == "left") {
        quizContentPlacementMobile = "row";
      } else if (field_item.options["quiz-content-placement-mobile"] == "right") {
        quizContentPlacementMobile = "row-reverse";
      } else if (field_item.options["quiz-content-placement-mobile"] == "above") {
        quizContentPlacementMobile = "column";
      } else if (element.options["quiz-content-placement-mobile"] == "below") {
        quizContentPlacementMobile = "column-reverse";
      } else if (element.options["quiz-content-placement-mobile"] == "left") {
        quizContentPlacementMobile = "row";
      } else if (element.options["quiz-content-placement-mobile"] == "right") {
        quizContentPlacementMobile = "row-reverse";
      } else {
        quizContentPlacementMobile = "column";
      }

      let quizContentWidthMobile = isValuePresent(field_item.options["quiz-content-width-mobile"])
        ? field_item.options["quiz-content-width-mobile"]
        : element.options["quiz-content-width-mobile"];

      let quizOptionTextAlignmentMobile = isValuePresent(field_item.options["quiz-option-text-alignment-mobile"])
        ? field_item.options["quiz-option-text-alignment-mobile"]
        : element.options["quiz-option-text-alignment-mobile"];

      let quizFieldLabelFontSizeMobile = field_item.options["quiz-label-font-size-mobile"] || element.options["quiz-label-font-size-mobile"];


      let quizLoadingSpinnerSizeMobile = isValuePresent(field_item.options["quiz-loading-spinner-size-mobile"])
        ? field_item.options["quiz-loading-spinner-size-mobile"]
        : isValuePresent(element.options["quiz-loading-spinner-size-mobile"])
          ? element.options["quiz-loading-spinner-size-mobile"]
          : isValuePresent(variant.options["quiz-loading-spinner-size-mobile"])
            ? variant.options["quiz-loading-spinner-size-mobile"]
            : undefined;

      mobileStyles += `
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-image-box {
          ${quizImagePlacementWidthMobile ? `width: ${quizImagePlacementWidthMobile} !important;` : ""}
          ${quizImagePlacementMobile == "left" ? "flex-shrink: 0;" : ""}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="radio"] .cf-selection-options,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="checkbox"] .cf-selection-options {
          ${quizContentAlignmentMarginMobile ? quizContentAlignmentMarginMobile : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-content-answers-wrapper[data-field-id="${field_item.id}"] {
          ${quizContentPlacementMobile ? `flex-direction: ${quizContentPlacementMobile} !important;` : ''}
          ${quizContentWidthMobile ? `max-width: ${quizContentWidthMobile}px !important;` : ''}
        }
        ${quizButtonsContentContainment(
          field_item.id,
          quizContentWidthMobile,
          isValuePresent(options["quiz-buttons-container-width-mobile"])
            ? options["quiz-buttons-container-width-mobile"]
            : options["quiz-buttons-container-width"]
        )}

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="image"] {
          ${quizImagePlacementMobile == "centered" ? 'flex-direction: column !important;' : ''}
          ${quizImagePlacementMobile == "left" ? 'flex-direction: row !important; flex-wrap: nowrap !important;' : 'flex-direction: column !important; flex-wrap: wrap !important;'}
          ${quizImagePlacementMobile == "left" ? 'gap: 10px !important;' : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-image {
          ${quizImagePlacementMobile == "left" ? 'display: block !important;' : 'display: inline !important;'}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] {
          ${options["cf-content-alignment-mobile"] == "cf-left" ? `margin: ${quizOptionsVerticalSpacingMobile || quizOptionsHorizontalSpacingMobile}px ${quizOptionsHorizontalSpacingMobile*2}px ${quizOptionsVerticalSpacingMobile || quizOptionsHorizontalSpacingMobile}px 0px !important;` : ''}
          ${options["cf-content-alignment-mobile"] == "cf-right" ? `margin: ${quizOptionsVerticalSpacingMobile || quizOptionsHorizontalSpacingMobile}px 0px ${quizOptionsVerticalSpacingMobile || quizOptionsHorizontalSpacingMobile}px ${quizOptionsHorizontalSpacingMobile*2}px !important;` : ''}
          ${options["cf-content-alignment-mobile"] == "cf-center" || !options["cf-content-alignment-mobile"] ? `margin: ${quizOptionsVerticalSpacingMobile || quizOptionsHorizontalSpacingMobile}px ${quizOptionsHorizontalSpacingMobile}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-quiz-answers-wrapper {
          ${quizOptionsLayoutMobile == "responsive" ? 'flex-direction: row !important; color: 1;' : ''}
          ${quizOptionsLayoutMobile == "stacked" ? 'flex-direction: column !important;' : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-loading-spinner {
          ${quizLoadingSpinnerSizeMobile ? `width: ${quizLoadingSpinnerSizeMobile}px !important; height: ${quizLoadingSpinnerSizeMobile}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-loading-bar,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-loading-spinner {
          ${field_item.options["loading-spacing-mobile"] ? `margin-top: ${field_item.options["loading-spacing-mobile"]}px; margin-bottom: ${field_item.options["loading-spacing-mobile"]}px; ` : 'margin-bottom: 30px; margin-top: 30px;'}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-quiz-answers-outer-wrapper {
          ${field_item.options["label-image-placement-mobile"] == "below" ? 'display: block !important;' : field_item.options["label-image-placement-mobile"] ? 'display: flex !important;' : ''}
          flex-wrap: wrap;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-quiz-answers-outer-wrapper img {
          max-width: 100%;
          margin-left: auto;
          margin-right: auto;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question[data-field-id="${field_item.id}"] .cf-quiz-label-image {
          ${field_item.options["label-image-width-mobile"] ? `width: ${field_item.options["label-image-width-mobile"]}px;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2 select.cf-sms-countries {
          ${quizConsideredFontSizeMobile ? `font-size: ${quizConsideredFontSizeMobile - 2}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-color {
          ${quizOptionColorSizeMobile ? `width: ${quizOptionColorSizeMobile}px !important;` : ''}
          ${quizOptionColorSizeMobile ? `height: ${quizOptionColorSizeMobile}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-letter {
          ${quizOptionVisualFontSizeMobile ? `font-size: ${quizOptionVisualFontSizeMobile*0.77}px !important;` : ""}
          width: ${quizOptionVisualFontSizeMobile * 1.5}px !important;
          height: ${quizOptionVisualFontSizeMobile * 1.5}px !important;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-emoji,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-icon svg {
          ${quizOptionVisualFontSizeMobile ? `font-size: ${quizOptionVisualFontSizeMobile}px;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-icon .svg-inline--fa {
          ${quizOptionVisualFontSizeMobile ? `font-size: ${quizOptionVisualFontSizeMobile}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-visual-box {
          ${quizVisualPlacementWidthMobile ? `min-width: ${quizVisualPlacementWidthMobile} !important;` : ""}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="color"] .cf-quiz-option-label,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="icon"] .cf-quiz-option-label,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="letter"] .cf-quiz-option-label,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="emoji"] .cf-quiz-option-label {
          ${field_item.label && quizVisualPlacementMobile == "left" ? 'padding-right: 15px; margin-bottom: 0px;' : ''}
          ${field_item.label && quizVisualPlacementMobile == "centered" ? 'margin-bottom: 15px; margin-right: auto;' : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-radio-option .cf-label {
          ${quizFieldLabelFontSizeMobile ? `font-size: ${quizFieldLabelFontSizeMobile}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-label {
          ${quizOptionFontSizeMobile ? `font-size: ${quizOptionFontSizeMobile}px;` : ''}
          ${quizOptionFontLineHeightMobile ? `line-height: ${quizOptionFontLineHeightMobile}px;` : ''}
          ${quizOptionTextAlignmentMobile == 'center' ? `margin-left: auto !important; margin-right: auto !important; text-align: center !important;` : ''}
          ${quizOptionTextAlignmentMobile == 'left' ? `margin-left: 0px !important; margin-right: auto !important; text-align: left !important;` : ''}
          ${quizOptionTextAlignmentMobile == 'right' ? `margin-right: 0px !important; margin-left: auto !important; text-align: right !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="text"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="date"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="datetime-local"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="email"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="tel"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default input[type="number"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default textarea,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-form-2.cf-form-theme-default select {
          ${quizFieldFontSizeMobile ? `font-size: ${quizFieldFontSizeMobile}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-image,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"] .cf-quiz-option-image-svg {
          ${quizOptionImageWidthMobile ? `width: ${quizOptionImageWidthMobile}px !important;` : ''}
          ${quizOptionImageHeightMobile ? `height: ${quizOptionImageHeightMobile}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="survey"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="radio_survey"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="image"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="color"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="icon"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="letter"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="emoji"] {
          ${quizOptionWidthMobile ? `width: ${quizOptionWidthMobile} !important;` : ''}
          ${quizOptionWidthMobile ? `max-width: 100% !important;` : ''}
          ${quizOptionHeightAuto(field_item) ? `justify-content: center;` : ''}
          ${quizOptionHeightAuto(field_item) ? `align-content: center;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="survey"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="color"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="icon"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="letter"],
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quiz-question-option[data-field-id="${field_item.id}"][data-field-type="emoji"] {
          ${quizVisualPlacementMobile == "left" ? 'flex-wrap: nowrap;' : 'flex-wrap: wrap;'}
          ${quizVisualPlacementMobile == "left" ? 'gap: 0px;' : 'gap: 5px;'}
        }
      `;
    })

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
